var _toConsumableArray = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");
var _defineProperty = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");
var _slicedToArray = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react/jsx-runtime'), require('react'), require('rdk'), require('framer-motion'), require('react-use-gesture'), require('elkjs/lib/elk.bundled'), require('p-cancelable'), require('calculate-size'), require('ellipsize'), require('react-cool-dimensions'), require('react-fast-compare'), require('kld-affine'), require('classnames'), require('d3-shape'), require('reakeys'), require('undoo'), require('kld-intersections')) : typeof define === 'function' && define.amd ? define(['exports', 'react/jsx-runtime', 'react', 'rdk', 'framer-motion', 'react-use-gesture', 'elkjs/lib/elk.bundled', 'p-cancelable', 'calculate-size', 'ellipsize', 'react-cool-dimensions', 'react-fast-compare', 'kld-affine', 'classnames', 'd3-shape', 'reakeys', 'undoo', 'kld-intersections'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.reaflow = {}, global.jsxRuntime, global.react, global.rdk, global.framerMotion, global.reactUseGesture, global.ELK, global.PCancelable, global.calculateSize, global.ellipsize, global.useDimensions, global.isEqual, global.kldAffine, global.classNames, global.d3Shape, global.reakeys, global.Undoo, global.kldIntersections));
})(this, function (exports, jsxRuntime, react, rdk, framerMotion, reactUseGesture, ELK, PCancelable, calculateSize, ellipsize, useDimensions, isEqual, kldAffine, classNames, d3Shape, reakeys, Undoo, kldIntersections) {
  function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
      'default': e
    };
  }
  var ELK__default = /*#__PURE__*/_interopDefaultLegacy(ELK);
  var PCancelable__default = /*#__PURE__*/_interopDefaultLegacy(PCancelable);
  var calculateSize__default = /*#__PURE__*/_interopDefaultLegacy(calculateSize);
  var ellipsize__default = /*#__PURE__*/_interopDefaultLegacy(ellipsize);
  var useDimensions__default = /*#__PURE__*/_interopDefaultLegacy(useDimensions);
  var isEqual__default = /*#__PURE__*/_interopDefaultLegacy(isEqual);
  var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
  var Undoo__default = /*#__PURE__*/_interopDefaultLegacy(Undoo);

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
    See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */

  function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  }
  var MAX_CHAR_COUNT = 35;
  var MIN_NODE_WIDTH = 50;
  var DEFAULT_NODE_HEIGHT = 50;
  var NODE_PADDING = 30;
  var ICON_PADDING = 10;
  function measureText(text) {
    var result = {
      height: 0,
      width: 0
    };
    if (text) {
      result = calculateSize__default['default'](text, {
        font: 'Arial, sans-serif',
        fontSize: '14px'
      });
    }
    return result;
  }
  function parsePadding(padding) {
    var top = 50;
    var right = 50;
    var bottom = 50;
    var left = 50;
    if (Array.isArray(padding)) {
      if (padding.length === 2) {
        top = padding[0];
        bottom = padding[0];
        left = padding[1];
        right = padding[1];
      } else if (padding.length === 4) {
        top = padding[0];
        right = padding[1];
        bottom = padding[2];
        left = padding[3];
      }
    } else if (padding !== undefined) {
      top = padding;
      right = padding;
      bottom = padding;
      left = padding;
    }
    return {
      top: top,
      right: right,
      bottom: bottom,
      left: left
    };
  }
  function formatText(node) {
    var text = node.text ? ellipsize__default['default'](node.text, MAX_CHAR_COUNT) : node.text;
    var labelDim = measureText(text);
    var nodePadding = parsePadding(node.nodePadding);
    var width = node.width;
    if (width === undefined) {
      if (text && node.icon) {
        width = labelDim.width + node.icon.width + NODE_PADDING + ICON_PADDING;
      } else {
        if (text) {
          width = labelDim.width + NODE_PADDING;
        } else if (node.icon) {
          width = node.icon.width + NODE_PADDING;
        }
        width = Math.max(width, MIN_NODE_WIDTH);
      }
    }
    var height = node.height;
    if (height === undefined) {
      if (text && node.icon) {
        height = labelDim.height + node.icon.height;
      } else if (text) {
        height = labelDim.height + NODE_PADDING;
      } else if (node.icon) {
        height = node.icon.height + NODE_PADDING;
      }
      height = Math.max(height, DEFAULT_NODE_HEIGHT);
    }
    return {
      text: text,
      originalText: node.text,
      width: width,
      height: height,
      nodePadding: nodePadding,
      labelHeight: labelDim.height,
      labelWidth: labelDim.width
    };
  }

  /**
   * ELK layout options applied by default, unless overridden through <Canvas layoutOptions> property.
   *
   * XXX Not to be confounded with ELK "defaultLayoutOptions" property, which is meant to be used as fallback, when no layout option is provided.
   *
   * @see https://www.eclipse.org/elk/reference/options.html
   */
  var defaultLayoutOptions = {
    /**
     * Hints for where node labels are to be placed; if empty, the node label’s position is not modified.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-nodeLabels-placement.html
     */
    'elk.nodeLabels.placement': 'INSIDE V_CENTER H_RIGHT',
    /**
     * Select a specific layout algorithm.
     *
     * Uses "layered" strategy.
     * It emphasizes the direction of edges by pointing as many edges as possible into the same direction.
     * The nodes are arranged in layers, which are sometimes called “hierarchies”,
     * and then reordered such that the number of edge crossings is minimized.
     * Afterwards, concrete coordinates are computed for the nodes and edge bend points.
     *
     * @see https://www.eclipse.org/elk/reference/algorithms.html
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-algorithm.html
     * @see https://www.eclipse.org/elk/reference/algorithms/org-eclipse-elk-layered.html
     */
    'elk.algorithm': 'org.eclipse.elk.layered',
    /**
     * Overall direction of edges: horizontal (right / left) or vertical (down / up).
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-direction.html
     */
    'elk.direction': 'DOWN',
    /**
     * Strategy for node layering.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-layered-layering-strategy.html
     */
    'org.eclipse.elk.layered.layering.strategy': 'INTERACTIVE',
    /**
     * What kind of edge routing style should be applied for the content of a parent node.
     * Algorithms may also set this option to single edges in order to mark them as splines.
     * The bend point list of edges with this option set to SPLINES
     * must be interpreted as control points for a piecewise cubic spline.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-edgeRouting.html
     */
    'org.eclipse.elk.edgeRouting': 'ORTHOGONAL',
    /**
     * Adds bend points even if an edge does not change direction.
     * If true, each long edge dummy will contribute a bend point to its edges
     * and hierarchy-crossing edges will always get a bend point where they cross hierarchy boundaries.
     * By default, bend points are only added where an edge changes direction.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-layered-unnecessaryBendpoints.html
     */
    'elk.layered.unnecessaryBendpoints': 'true',
    /**
     * The spacing to be preserved between nodes and edges that are routed next to the node’s layer.
     * For the spacing between nodes and edges that cross the node’s layer ‘spacing.edgeNode’ is used.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-layered-spacing-edgeNodeBetweenLayers.html
     */
    'elk.layered.spacing.edgeNodeBetweenLayers': '50',
    /**
     * Tells the BK node placer to use a certain alignment (out of its four)
     * instead of the one producing the smallest height, or the combination of all four.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-layered-nodePlacement-bk-fixedAlignment.html
     */
    'org.eclipse.elk.layered.nodePlacement.bk.fixedAlignment': 'BALANCED',
    /**
     * Strategy for cycle breaking.
     *
     * Cycle breaking looks for cycles in the graph and determines which edges to reverse to break the cycles.
     * Reversed edges will end up pointing to the opposite direction of regular edges
     * (that is, reversed edges will point left if edges usually point right).
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-layered-cycleBreaking-strategy.html
     */
    'org.eclipse.elk.layered.cycleBreaking.strategy': 'DEPTH_FIRST',
    /**
     * Whether this node allows to route self loops inside of it instead of around it.
     *
     * If set to true, this will make the node a compound node if it isn’t already,
     * and will require the layout algorithm to support compound nodes with hierarchical ports.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-insideSelfLoops-activate.html
     */
    'org.eclipse.elk.insideSelfLoops.activate': 'true',
    /**
     * Whether each connected component should be processed separately.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-separateConnectedComponents.html
     */
    separateConnectedComponents: 'false',
    /**
     * Spacing to be preserved between pairs of connected components.
     * This option is only relevant if ‘separateConnectedComponents’ is activated.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-spacing-componentComponent.html
     */
    'spacing.componentComponent': '70',
    /**
     * TODO: Should be spacing.baseValue?
     * An optional base value for all other layout options of the ‘spacing’ group.
     * It can be used to conveniently alter the overall ‘spaciousness’ of the drawing.
     * Whenever an explicit value is set for the other layout options, this base value will have no effect.
     * The base value is not inherited, i.e. it must be set for each hierarchical node.
     *
     * @see https://www.eclipse.org/elk/reference/groups/org-eclipse-elk-layered-spacing.html
     */
    spacing: '75',
    /**
     * The spacing to be preserved between any pair of nodes of two adjacent layers.
     * Note that ‘spacing.nodeNode’ is used for the spacing between nodes within the layer itself.
     *
     * @see https://www.eclipse.org/elk/reference/options/org-eclipse-elk-layered-spacing-nodeNodeBetweenLayers.html
     */
    'spacing.nodeNodeBetweenLayers': '70'
  };
  function mapNode(nodes, edges, node) {
    var _formatText = formatText(node),
      text = _formatText.text,
      width = _formatText.width,
      height = _formatText.height,
      labelHeight = _formatText.labelHeight,
      labelWidth = _formatText.labelWidth,
      nodePadding = _formatText.nodePadding,
      originalText = _formatText.originalText;
    var children = nodes.filter(function (n) {
      return n.parent === node.id;
    }).map(function (n) {
      return mapNode(nodes, edges, n);
    });
    var childEdges = edges.filter(function (e) {
      return e.parent === node.id;
    }).map(function (e) {
      return mapEdge(e);
    });
    var nodeLayoutOptions = Object.assign({
      'elk.padding': "[left=".concat(nodePadding.left, ", top=").concat(nodePadding.top, ", right=").concat(nodePadding.right, ", bottom=").concat(nodePadding.bottom, "]"),
      portConstraints: 'FIXED_ORDER'
    }, node.layoutOptions || {});
    return {
      id: node.id,
      height: height,
      width: width,
      children: children,
      edges: childEdges,
      ports: node.ports ? node.ports.map(function (port) {
        return {
          id: port.id,
          properties: Object.assign(Object.assign({}, port), {
            'port.side': port.side,
            'port.alignment': port.alignment || 'CENTER'
          })
        };
      }) : [],
      layoutOptions: nodeLayoutOptions,
      properties: Object.assign({}, node),
      labels: text ? [{
        width: labelWidth,
        height: -(labelHeight / 2),
        text: text,
        originalText: originalText
        // layoutOptions: { 'elk.nodeLabels.placement': 'INSIDE V_CENTER H_CENTER' }
      }] : []
    };
  }
  function mapEdge(_a) {
    var data = _a.data,
      edge = __rest(_a, ["data"]);
    var labelDim = measureText(edge.text);
    var validEdgeData = data ? {
      data: data
    } : {};
    return Object.assign(Object.assign({
      id: edge.id,
      source: edge.from,
      target: edge.to,
      properties: Object.assign({}, edge)
    }, validEdgeData), {
      sourcePort: edge.fromPort,
      targetPort: edge.toPort,
      labels: edge.text ? [{
        width: labelDim.width / 2,
        height: -(labelDim.height / 2),
        text: edge.text,
        layoutOptions: {
          'elk.edgeLabels.placement': 'INSIDE V_CENTER H_CENTER'
        }
      }] : []
    });
  }
  function mapInput(nodes, edges) {
    var children = [];
    var mappedEdges = [];
    var _iterator = _createForOfIteratorHelper(nodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;
        if (!node.parent) {
          var mappedNode = mapNode(nodes, edges, node);
          if (mappedNode !== null) {
            children.push(mappedNode);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var _iterator2 = _createForOfIteratorHelper(edges),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var edge = _step2.value;
        if (!edge.parent) {
          var mappedEdge = mapEdge(edge);
          if (mappedEdge !== null) {
            mappedEdges.push(mappedEdge);
          }
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return {
      children: children,
      edges: mappedEdges
    };
  }
  function postProcessNode(nodes) {
    var _a;
    var _iterator3 = _createForOfIteratorHelper(nodes),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var node = _step3.value;
        var hasLabels = ((_a = node.labels) === null || _a === void 0 ? void 0 : _a.length) > 0;
        if (hasLabels && node.properties.icon) {
          var _node$labels = _slicedToArray(node.labels, 1),
            label = _node$labels[0];
          label.x = node.properties.icon.width + 25;
          node.properties.icon.x = 25;
          node.properties.icon.y = node.height / 2;
        } else if (hasLabels) {
          var _node$labels2 = _slicedToArray(node.labels, 1),
            _label = _node$labels2[0];
          _label.x = (node.width - _label.width) / 2;
        } else if (node.properties.icon) {
          node.properties.icon.x = node.width / 2;
          node.properties.icon.y = node.height / 2;
        }
        if (node.children) {
          postProcessNode(node.children);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return nodes;
  }
  var elkLayout = function elkLayout(nodes, edges, options) {
    var graph = new ELK__default['default']();
    var layoutOptions = Object.assign(Object.assign({}, defaultLayoutOptions), options);
    return new PCancelable__default['default'](function (resolve, reject) {
      graph.layout(Object.assign({
        id: 'root'
      }, mapInput(nodes, edges)), {
        layoutOptions: layoutOptions
      }).then(function (data) {
        resolve(Object.assign(Object.assign({}, data), {
          children: postProcessNode(data.children)
        }));
      }).catch(reject);
    });
  };
  var useLayout = function useLayout(_ref) {
    var maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      _ref$nodes = _ref.nodes,
      nodes = _ref$nodes === void 0 ? [] : _ref$nodes,
      _ref$edges = _ref.edges,
      edges = _ref$edges === void 0 ? [] : _ref$edges,
      fit = _ref.fit,
      pannable = _ref.pannable,
      center = _ref.center,
      direction = _ref.direction,
      _ref$layoutOptions = _ref.layoutOptions,
      layoutOptions = _ref$layoutOptions === void 0 ? {} : _ref$layoutOptions,
      zoom = _ref.zoom,
      setZoom = _ref.setZoom,
      onLayoutChange = _ref.onLayoutChange;
    var scrolled = react.useRef(false);
    var ref = react.useRef();
    var _useDimensions__defau = useDimensions__default['default'](),
      observe = _useDimensions__defau.observe,
      width = _useDimensions__defau.width,
      height = _useDimensions__defau.height;
    var _react$useState = react.useState(null),
      _react$useState2 = _slicedToArray(_react$useState, 2),
      layout = _react$useState2[0],
      setLayout = _react$useState2[1];
    var _react$useState3 = react.useState([0, 0]),
      _react$useState4 = _slicedToArray(_react$useState3, 2),
      xy = _react$useState4[0],
      setXY = _react$useState4[1];
    var _react$useState5 = react.useState([0, 0]),
      _react$useState6 = _slicedToArray(_react$useState5, 2),
      scrollXY = _react$useState6[0],
      setScrollXY = _react$useState6[1];
    var canvasHeight = pannable ? maxHeight : height;
    var canvasWidth = pannable ? maxWidth : width;
    react.useEffect(function () {
      var promise = elkLayout(nodes, edges, Object.assign({
        'elk.direction': direction
      }, layoutOptions));
      promise.then(function (result) {
        if (!isEqual__default['default'](layout, result)) {
          setLayout(result);
          onLayoutChange(result);
        }
      }).catch(function (err) {
        if (err.name !== 'CancelError') {
          console.error('Layout Error:', err);
        }
      });
      return function () {
        return promise.cancel();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodes, edges]);
    var centerVector = react.useCallback(function () {
      if (center && layout) {
        // @ts-ignore
        var x = (canvasWidth - layout.width * zoom) / 2;
        // @ts-ignore
        var y = (canvasHeight - layout.height * zoom) / 2;
        setXY([x, y]);
      }
    }, [canvasWidth, canvasHeight, layout, zoom, center]);
    var centerScroll = react.useCallback(function () {
      var scrollX = (canvasWidth - width) / 2;
      var scrollY = (canvasHeight - height) / 2;
      if (pannable) {
        setScrollXY([scrollX, scrollY]);
      }
    }, [canvasWidth, canvasHeight, width, height, pannable]);
    var centerCanvas = react.useCallback(function () {
      centerVector();
      centerScroll();
    }, [centerScroll, centerVector]);
    react.useEffect(function () {
      var _a;
      (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollTo(scrollXY[0], scrollXY[1]);
    }, [scrollXY, ref]);
    react.useEffect(function () {
      if (scrolled.current) {
        centerVector();
      }
    }, [centerVector, zoom]);
    var fitCanvas = react.useCallback(function () {
      if (layout) {
        var heightZoom = height / layout.height;
        var widthZoom = width / layout.width;
        var scale = Math.min(heightZoom, widthZoom, 1);
        setZoom(scale - 1);
        centerCanvas();
      }
    }, [height, layout, width, setZoom, centerCanvas]);
    react.useLayoutEffect(function () {
      var scroller = ref.current;
      if (scroller && !scrolled.current && layout && height && width) {
        if (fit) {
          fitCanvas();
        } else {
          centerCanvas();
        }
        scrolled.current = true;
      }
    }, [canvasWidth, pannable, canvasHeight, layout, height, fit, width, center, centerCanvas, fitCanvas, ref]);
    react.useLayoutEffect(function () {
      function onResize() {
        if (fit) {
          fitCanvas();
        } else {
          centerCanvas();
        }
      }
      window.addEventListener('resize', onResize);
      return function () {
        return window.removeEventListener('resize', onResize);
      };
    }, [fit, centerCanvas, fitCanvas]);
    return {
      xy: xy,
      observe: observe,
      containerRef: ref,
      canvasHeight: canvasHeight,
      canvasWidth: canvasWidth,
      containerWidth: width,
      containerHeight: height,
      layout: layout,
      scrollXY: scrollXY,
      centerCanvas: centerCanvas,
      fitCanvas: fitCanvas
    };
  };
  var useEdgeDrag = function useEdgeDrag(_ref2) {
    var onNodeLink = _ref2.onNodeLink,
      onNodeLinkCheck = _ref2.onNodeLinkCheck;
    var _react$useState7 = react.useState(null),
      _react$useState8 = _slicedToArray(_react$useState7, 2),
      dragNode = _react$useState8[0],
      setDragNode = _react$useState8[1];
    var _react$useState9 = react.useState(null),
      _react$useState10 = _slicedToArray(_react$useState9, 2),
      dragPort = _react$useState10[0],
      setDragPort = _react$useState10[1];
    var _react$useState11 = react.useState(null),
      _react$useState12 = _slicedToArray(_react$useState11, 2),
      dragType = _react$useState12[0],
      setDragType = _react$useState12[1];
    var _react$useState13 = react.useState(null),
      _react$useState14 = _slicedToArray(_react$useState13, 2),
      enteredNode = _react$useState14[0],
      setEnteredNode = _react$useState14[1];
    var _react$useState15 = react.useState(null),
      _react$useState16 = _slicedToArray(_react$useState15, 2),
      dragCoords = _react$useState16[0],
      setDragCoords = _react$useState16[1];
    var _react$useState17 = react.useState(null),
      _react$useState18 = _slicedToArray(_react$useState17, 2),
      canLinkNode = _react$useState18[0],
      setCanLinkNode = _react$useState18[1];
    var onDragStart = react.useCallback(function (state, _initial, node, port) {
      setDragType(state.dragType);
      setDragNode(node);
      setDragPort(port);
    }, []);
    var onDrag = react.useCallback(function (_ref3, _ref4) {
      var _ref3$memo = _slicedToArray(_ref3.memo, 1),
        matrix = _ref3$memo[0],
        _ref3$xy = _slicedToArray(_ref3.xy, 2),
        x = _ref3$xy[0],
        y = _ref3$xy[1];
      var _ref5 = _slicedToArray(_ref4, 2),
        ix = _ref5[0],
        iy = _ref5[1];
      var endPoint = new kldAffine.Point2D(x, y).transform(matrix);
      setDragCoords([{
        startPoint: {
          x: ix,
          y: iy
        },
        endPoint: endPoint
      }]);
    }, []);
    var onDragEnd = react.useCallback(function (event) {
      if (dragNode && enteredNode && canLinkNode) {
        onNodeLink(event, dragNode, enteredNode, dragPort);
      }
      setDragNode(null);
      setDragPort(null);
      setEnteredNode(null);
      setDragCoords(null);
    }, [canLinkNode, dragNode, dragPort, enteredNode, onNodeLink]);
    var onEnter = react.useCallback(function (event, node) {
      if (dragNode && node) {
        setEnteredNode(node);
        var canLink = onNodeLinkCheck(event, dragNode, node, dragPort);
        var result = (canLink === undefined || canLink) && (dragNode.parent === node.parent || dragType === 'node');
        setCanLinkNode(result);
      }
    }, [dragNode, dragPort, dragType, onNodeLinkCheck]);
    var onLeave = react.useCallback(function (event, node) {
      if (dragNode && node) {
        setEnteredNode(null);
        setCanLinkNode(null);
      }
    }, [dragNode]);
    return {
      dragCoords: dragCoords,
      canLinkNode: canLinkNode,
      dragNode: dragNode,
      dragPort: dragPort,
      enteredNode: enteredNode,
      onDragStart: onDragStart,
      onDrag: onDrag,
      onDragEnd: onDragEnd,
      onEnter: onEnter,
      onLeave: onLeave
    };
  };
  var limit = function limit(scale, min, max) {
    return scale < max ? scale > min ? scale : min : max;
  };
  var useZoom = function useZoom(_ref6) {
    var _ref6$disabled = _ref6.disabled,
      disabled = _ref6$disabled === void 0 ? false : _ref6$disabled,
      _ref6$zoom = _ref6.zoom,
      zoom = _ref6$zoom === void 0 ? 1 : _ref6$zoom,
      _ref6$minZoom = _ref6.minZoom,
      minZoom = _ref6$minZoom === void 0 ? -0.5 : _ref6$minZoom,
      _ref6$maxZoom = _ref6.maxZoom,
      maxZoom = _ref6$maxZoom === void 0 ? 1 : _ref6$maxZoom,
      onZoomChange = _ref6.onZoomChange;
    var _react$useState19 = react.useState(zoom - 1),
      _react$useState20 = _slicedToArray(_react$useState19, 2),
      factor = _react$useState20[0],
      setFactor = _react$useState20[1];
    var svgRef = react.useRef(null);
    reactUseGesture.useGesture({
      onPinch: function onPinch(_ref7) {
        var _ref7$offset = _slicedToArray(_ref7.offset, 1),
          d = _ref7$offset[0],
          event = _ref7.event;
        event.preventDefault();
        // TODO: Set X/Y on center of zoom
        var next = limit(d / 100, minZoom, maxZoom);
        setFactor(next);
        onZoomChange(next + 1);
      }
    }, {
      enabled: !disabled,
      domTarget: svgRef,
      eventOptions: {
        passive: false
      }
    });
    var setZoom = react.useCallback(function (f) {
      var next = limit(f, minZoom, maxZoom);
      setFactor(next);
      onZoomChange(next + 1);
    }, [maxZoom, minZoom, onZoomChange]);
    var zoomIn = react.useCallback(function () {
      setZoom(factor + 0.1);
    }, [factor, setZoom]);
    var zoomOut = react.useCallback(function () {
      setZoom(factor - 0.1);
    }, [factor, setZoom]);
    return {
      svgRef: svgRef,
      zoom: factor + 1,
      setZoom: setZoom,
      zoomIn: zoomIn,
      zoomOut: zoomOut
    };
  };
  var CanvasContext = react.createContext({});
  var CanvasProvider = function CanvasProvider(_ref8) {
    var selections = _ref8.selections,
      onNodeLink = _ref8.onNodeLink,
      readonly = _ref8.readonly,
      children = _ref8.children,
      nodes = _ref8.nodes,
      edges = _ref8.edges,
      maxHeight = _ref8.maxHeight,
      fit = _ref8.fit,
      maxWidth = _ref8.maxWidth,
      direction = _ref8.direction,
      layoutOptions = _ref8.layoutOptions,
      pannable = _ref8.pannable,
      center = _ref8.center,
      zoomable = _ref8.zoomable,
      zoom = _ref8.zoom,
      minZoom = _ref8.minZoom,
      maxZoom = _ref8.maxZoom,
      onNodeLinkCheck = _ref8.onNodeLinkCheck,
      onLayoutChange = _ref8.onLayoutChange,
      onZoomChange = _ref8.onZoomChange;
    var zoomProps = useZoom({
      zoom: zoom,
      minZoom: minZoom,
      maxZoom: maxZoom,
      disabled: !zoomable,
      onZoomChange: onZoomChange
    });
    var layoutProps = useLayout({
      nodes: nodes,
      edges: edges,
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      direction: direction,
      pannable: pannable,
      center: center,
      fit: fit,
      layoutOptions: layoutOptions,
      zoom: zoomProps.zoom,
      setZoom: zoomProps.setZoom,
      onLayoutChange: onLayoutChange
    });
    var dragProps = useEdgeDrag({
      onNodeLink: onNodeLink,
      onNodeLinkCheck: onNodeLinkCheck
    });
    return jsxRuntime.jsx(CanvasContext.Provider, Object.assign({
      value: Object.assign(Object.assign(Object.assign({
        selections: selections,
        readonly: readonly,
        pannable: pannable
      }, layoutProps), zoomProps), dragProps)
    }, {
      children: children
    }), void 0);
  };
  var useCanvas = function useCanvas() {
    var context = react.useContext(CanvasContext);
    if (context === undefined) {
      throw new Error('`useCanvas` hook must be used within a `CanvasContext` component');
    }
    return context;
  };

  /**
   * Checks if the node can be linked or not.
   */
  function checkNodeLinkable(curNode, enteredNode, canLinkNode) {
    if (canLinkNode === null || !enteredNode) {
      return null;
    }
    if (!enteredNode || !curNode) {
      return false;
    }
    // TODO: Revisit how to do self-linking better...
    if (canLinkNode === false && enteredNode.id === curNode.id) {
      return false;
    }
    return true;
  }
  /**
   * Given various dimensions and positions, create a matrix
   * used for determining position.
   */
  function getCoords(_ref9) {
    var zoom = _ref9.zoom,
      scrollXY = _ref9.scrollXY,
      layout = _ref9.layout,
      containerWidth = _ref9.containerWidth,
      containerHeight = _ref9.containerHeight,
      containerRef = _ref9.containerRef;
    var _containerRef$current = containerRef.current.getBoundingClientRect(),
      top = _containerRef$current.top,
      left = _containerRef$current.left;
    var offsetX = scrollXY[0] - containerRef.current.scrollLeft;
    var offsetY = scrollXY[1] - containerRef.current.scrollTop;
    var tx = (containerWidth - layout.width * zoom) / 2 + offsetX + left;
    var ty = (containerHeight - layout.height * zoom) / 2 + offsetY + top;
    return new kldAffine.Matrix2D().translate(tx, ty).scale(zoom).inverse();
  }
  /**
   * Given a nodeId to find, a list of nodes to check against, and an optional parentId of the node
   * find the node from the list of nodes
   */
  function findNestedNode(nodeId, children, parentId) {
    if (!nodeId || !children) {
      return {};
    }
    var foundNode = children.find(function (n) {
      return n.id === nodeId;
    });
    if (foundNode) {
      return foundNode;
    }
    if (parentId) {
      var parentNode = children.find(function (n) {
        return n.id === parentId;
      });
      if (parentNode === null || parentNode === void 0 ? void 0 : parentNode.children) {
        return findNestedNode(nodeId, parentNode.children, parentId);
      }
    }
    // Check for nested children
    var nodesWithChildren = children.filter(function (n) {
      var _a;
      return (_a = n.children) === null || _a === void 0 ? void 0 : _a.length;
    });
    // Iterate over all nested nodes and check if any of them contain the node
    var _iterator4 = _createForOfIteratorHelper(nodesWithChildren),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var n = _step4.value;
        var foundChild = findNestedNode(nodeId, n.children, parentId);
        if (foundChild && Object.keys(foundChild).length) {
          return foundChild;
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    return {};
  }
  /**
   * Return the layout node that is currently being dragged on the Canvas
   */
  function getDragNodeData(dragNode) {
    var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!dragNode) {
      return {};
    }
    var parent = dragNode.parent;
    if (!parent) {
      return (children === null || children === void 0 ? void 0 : children.find(function (n) {
        return n.id === dragNode.id;
      })) || {};
    }
    return findNestedNode(dragNode.id, children, parent);
  }
  var useNodeDrag = function useNodeDrag(_ref10) {
    var x = _ref10.x,
      y = _ref10.y,
      height = _ref10.height,
      width = _ref10.width,
      onDrag = _ref10.onDrag,
      onDragEnd = _ref10.onDragEnd,
      onDragStart = _ref10.onDragStart,
      node = _ref10.node,
      disabled = _ref10.disabled;
    var initial = [width / 2 + x, height + y];
    var targetRef = react.useRef(null);
    var _useCanvas = useCanvas(),
      zoom = _useCanvas.zoom,
      scrollXY = _useCanvas.scrollXY,
      layout = _useCanvas.layout,
      containerWidth = _useCanvas.containerWidth,
      containerRef = _useCanvas.containerRef,
      containerHeight = _useCanvas.containerHeight;
    var bind = reactUseGesture.useDrag(function (state) {
      if (state.event.type === 'pointerdown') {
        targetRef.current = state.event.currentTarget;
      }
      if (!state.intentional || !targetRef.current) {
        return;
      }
      if (state.first) {
        var matrix = getCoords({
          containerRef: containerRef,
          zoom: zoom,
          layout: layout,
          scrollXY: scrollXY,
          containerHeight: containerHeight,
          containerWidth: containerWidth
        });
        // memo will hold the difference between the
        // first point of impact and the origin
        var memo = [matrix];
        onDragStart(Object.assign(Object.assign({}, state), {
          memo: memo
        }), initial, node);
        return memo;
      }
      onDrag(state, initial, node);
      if (state.last) {
        targetRef.current = null;
        onDragEnd(state, initial, node);
      }
    }, {
      enabled: !disabled,
      triggerAllEvents: true,
      threshold: 5
    });
    return bind;
  };
  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') {
      return;
    }
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }
  var css_248z = ".Port-module_port__30o1q {\n  stroke: #0d0e17;\n  fill: #3e405a;\n  stroke-width: 2px;\n  shape-rendering: geometricPrecision;\n  pointer-events: none;\n}\n\n.Port-module_clicker__ZivO1 {\n  opacity: 0;\n}\n\n.Port-module_clicker__ZivO1:not(.Port-module_disabled__1SC1t) {\n    cursor: crosshair;\n  }\n";
  var css = {
    "port": "Port-module_port__30o1q",
    "clicker": "Port-module_clicker__ZivO1",
    "disabled": "Port-module_disabled__1SC1t"
  };
  styleInject(css_248z);
  var Port = react.forwardRef(function (_ref11, ref) {
    var id = _ref11.id,
      x = _ref11.x,
      y = _ref11.y,
      rx = _ref11.rx,
      ry = _ref11.ry,
      disabled = _ref11.disabled,
      style = _ref11.style,
      children = _ref11.children,
      properties = _ref11.properties,
      offsetX = _ref11.offsetX,
      offsetY = _ref11.offsetY,
      className = _ref11.className,
      active = _ref11.active,
      _ref11$onDrag = _ref11.onDrag,
      onDrag = _ref11$onDrag === void 0 ? function () {
        return undefined;
      } : _ref11$onDrag,
      _ref11$onDragStart = _ref11.onDragStart,
      onDragStart = _ref11$onDragStart === void 0 ? function () {
        return undefined;
      } : _ref11$onDragStart,
      _ref11$onDragEnd = _ref11.onDragEnd,
      onDragEnd = _ref11$onDragEnd === void 0 ? function () {
        return undefined;
      } : _ref11$onDragEnd,
      _ref11$onEnter = _ref11.onEnter,
      onEnter = _ref11$onEnter === void 0 ? function () {
        return undefined;
      } : _ref11$onEnter,
      _ref11$onLeave = _ref11.onLeave,
      onLeave = _ref11$onLeave === void 0 ? function () {
        return undefined;
      } : _ref11$onLeave,
      _ref11$onClick = _ref11.onClick,
      _onClick = _ref11$onClick === void 0 ? function () {
        return undefined;
      } : _ref11$onClick;
    var _useCanvas2 = useCanvas(),
      readonly = _useCanvas2.readonly;
    var _react$useState21 = react.useState(false),
      _react$useState22 = _slicedToArray(_react$useState21, 2),
      isDragging = _react$useState22[0],
      setIsDragging = _react$useState22[1];
    var _react$useState23 = react.useState(false),
      _react$useState24 = _slicedToArray(_react$useState23, 2),
      isHovered = _react$useState24[0],
      setIsHovered = _react$useState24[1];
    var newX = x - properties.width / 2;
    var newY = y - properties.height / 2;
    var onDragStartInternal = function onDragStartInternal(event, initial) {
      onDragStart(event, initial, properties);
      setIsDragging(true);
    };
    var onDragEndInternal = function onDragEndInternal(event, initial) {
      onDragEnd(event, initial, properties);
      setIsDragging(false);
    };
    var bind = useNodeDrag({
      x: newX + offsetX,
      y: newY + offsetY,
      height: properties.height,
      width: properties.width,
      disabled: disabled || readonly || (properties === null || properties === void 0 ? void 0 : properties.disabled),
      node: properties,
      onDrag: onDrag,
      onDragStart: onDragStartInternal,
      onDragEnd: onDragEndInternal
    });
    if (properties.hidden) {
      return null;
    }
    var isDisabled = properties.disabled || disabled;
    var portChildProps = {
      port: properties,
      isDragging: isDragging,
      isHovered: isHovered,
      isDisabled: isDisabled,
      x: x,
      y: y,
      rx: rx,
      ry: ry,
      offsetX: offsetX,
      offsetY: offsetY
    };
    return jsxRuntime.jsxs("g", Object.assign({
      id: id
    }, {
      children: [jsxRuntime.jsx("rect", Object.assign({}, bind(), {
        ref: ref,
        height: properties.height + 14,
        width: properties.width + 14,
        x: newX - 7,
        y: newY - 7,
        className: classNames__default['default'](css.clicker, _defineProperty({}, css.disabled, isDisabled)),
        onMouseEnter: function onMouseEnter(event) {
          event.stopPropagation();
          if (!isDisabled) {
            setIsHovered(true);
            onEnter(event, properties);
          }
        },
        onMouseLeave: function onMouseLeave(event) {
          event.stopPropagation();
          if (!isDisabled) {
            setIsHovered(false);
            onLeave(event, properties);
          }
        },
        onClick: function onClick(event) {
          event.stopPropagation();
          if (!isDisabled) {
            _onClick(event, properties);
          }
        }
      }), void 0), jsxRuntime.jsx(framerMotion.motion.rect, {
        style: style,
        className: classNames__default['default'](css.port, className, properties === null || properties === void 0 ? void 0 : properties.className),
        height: properties.height,
        width: properties.width,
        rx: rx,
        ry: ry,
        initial: {
          scale: 0,
          opacity: 0,
          x: newX,
          y: newY
        },
        animate: {
          x: newX,
          y: newY,
          scale: (isDragging || active || isHovered) && !isDisabled ? 1.5 : 1,
          opacity: 1
        }
      }, "".concat(x, "-").concat(y)), children && jsxRuntime.jsx(react.Fragment, {
        children: typeof children === 'function' ? children(portChildProps) : children
      }, void 0)]
    }), void 0);
  });
  var css_248z$1 = ".Label-module_text__126dD {\n  fill: #d6e7ff;\n  pointer-events: none;\n  font-size: 14px;\n  text-rendering: geometricPrecision;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n";
  var css$1 = {
    "text": "Label-module_text__126dD"
  };
  styleInject(css_248z$1);
  var Label = function Label(_ref12) {
    var text = _ref12.text,
      x = _ref12.x,
      y = _ref12.y,
      style = _ref12.style,
      className = _ref12.className,
      originalText = _ref12.originalText;
    return jsxRuntime.jsxs("g", Object.assign({
      transform: "translate(".concat(x, ", ").concat(y, ")")
    }, {
      children: [jsxRuntime.jsx("title", {
        children: originalText
      }, void 0), jsxRuntime.jsx("text", Object.assign({
        className: classNames__default['default'](css$1.text, className),
        style: style
      }, {
        children: text
      }), void 0)]
    }), void 0);
  };
  var css_248z$2 = ".Remove-module_deleteX__2x11N {\n  stroke: black;\n  pointer-events: none;\n}\n\n.Remove-module_container__19Jsk {\n  will-change: transform, opacity;\n}\n\n.Remove-module_drop__2AwP8 {\n  cursor: pointer;\n  opacity: 0;\n}\n\n.Remove-module_rect__3vmn2 {\n  shape-rendering: geometricPrecision;\n  fill: #ff005d;\n  border-radius: 2px;\n  pointer-events: none;\n}\n";
  var css$2 = {
    "deleteX": "Remove-module_deleteX__2x11N",
    "container": "Remove-module_container__19Jsk",
    "drop": "Remove-module_drop__2AwP8",
    "rect": "Remove-module_rect__3vmn2"
  };
  styleInject(css_248z$2);
  var Remove = function Remove(_ref13) {
    var _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 15 : _ref13$size,
      className = _ref13.className,
      hidden = _ref13.hidden,
      x = _ref13.x,
      y = _ref13.y,
      _ref13$onClick = _ref13.onClick,
      _onClick2 = _ref13$onClick === void 0 ? function () {
        return undefined;
      } : _ref13$onClick,
      _ref13$onEnter = _ref13.onEnter,
      onEnter = _ref13$onEnter === void 0 ? function () {
        return undefined;
      } : _ref13$onEnter,
      _ref13$onLeave = _ref13.onLeave,
      onLeave = _ref13$onLeave === void 0 ? function () {
        return undefined;
      } : _ref13$onLeave;
    if (hidden) {
      return null;
    }
    var half = size / 2;
    var translateX = x - half;
    var translateY = y - half;
    return jsxRuntime.jsxs(framerMotion.motion.g, Object.assign({
      className: classNames__default['default'](className, css$2.container),
      initial: {
        scale: 0,
        opacity: 0,
        translateX: translateX,
        translateY: translateY
      },
      animate: {
        scale: 1,
        opacity: 1,
        translateX: translateX,
        translateY: translateY
      },
      whileHover: {
        scale: 1.2
      },
      whileTap: {
        scale: 0.8
      }
    }, {
      children: [jsxRuntime.jsx("rect", {
        height: size * 1.5,
        width: size * 1.5,
        className: css$2.drop,
        onMouseEnter: onEnter,
        onMouseLeave: onLeave,
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          _onClick2(event);
        }
      }, void 0), jsxRuntime.jsx("rect", {
        height: size,
        width: size,
        className: css$2.rect
      }, void 0), jsxRuntime.jsx("line", {
        x1: "2",
        y1: size - 2,
        x2: size - 2,
        y2: "2",
        className: css$2.deleteX,
        strokeWidth: "1"
      }, void 0), jsxRuntime.jsx("line", {
        x1: "2",
        y1: "2",
        x2: size - 2,
        y2: size - 2,
        className: css$2.deleteX,
        strokeWidth: "1"
      }, void 0)]
    }), void 0);
  };

  /**
   * Center helper.
   * Ref: https://github.com/wbkd/react-flow/blob/main/src/components/Edges/utils.ts#L18
   */
  function getBezierCenter(_ref14) {
    var sourceX = _ref14.sourceX,
      sourceY = _ref14.sourceY,
      targetX = _ref14.targetX,
      targetY = _ref14.targetY;
    var xOffset = Math.abs(targetX - sourceX) / 2;
    var centerX = targetX < sourceX ? targetX + xOffset : targetX - xOffset;
    var yOffset = Math.abs(targetY - sourceY) / 2;
    var centerY = targetY < sourceY ? targetY + yOffset : targetY - yOffset;
    return [centerX, centerY, xOffset, yOffset];
  }
  /**
   * Path helper utils.
   * Ref: https://github.com/wbkd/react-flow/blob/main/src/components/Edges/BezierEdge.tsx#L19
   */
  function getBezierPath(_ref15) {
    var sourceX = _ref15.sourceX,
      sourceY = _ref15.sourceY,
      _ref15$sourcePosition = _ref15.sourcePosition,
      sourcePosition = _ref15$sourcePosition === void 0 ? 'bottom' : _ref15$sourcePosition,
      targetX = _ref15.targetX,
      targetY = _ref15.targetY,
      _ref15$targetPosition = _ref15.targetPosition,
      targetPosition = _ref15$targetPosition === void 0 ? 'top' : _ref15$targetPosition;
    var leftAndRight = ['left', 'right'];
    var _getBezierCenter = getBezierCenter({
        sourceX: sourceX,
        sourceY: sourceY,
        targetX: targetX,
        targetY: targetY
      }),
      _getBezierCenter2 = _slicedToArray(_getBezierCenter, 2),
      centerX = _getBezierCenter2[0],
      centerY = _getBezierCenter2[1];
    var path = "M".concat(sourceX, ",").concat(sourceY, " C").concat(sourceX, ",").concat(centerY, " ").concat(targetX, ",").concat(centerY, " ").concat(targetX, ",").concat(targetY);
    if (leftAndRight.includes(sourcePosition) && leftAndRight.includes(targetPosition)) {
      path = "M".concat(sourceX, ",").concat(sourceY, " C").concat(centerX, ",").concat(sourceY, " ").concat(centerX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY);
    } else if (leftAndRight.includes(targetPosition)) {
      path = "M".concat(sourceX, ",").concat(sourceY, " C").concat(sourceX, ",").concat(targetY, " ").concat(sourceX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY);
    } else if (leftAndRight.includes(sourcePosition)) {
      path = "M".concat(sourceX, ",").concat(sourceY, " C").concat(targetX, ",").concat(sourceY, " ").concat(targetX, ",").concat(sourceY, " ").concat(targetX, ",").concat(targetY);
    }
    return path;
  }
  /**
   * Calculate actual center for a path element.
   */
  function getCenter(pathElm) {
    var pLength = pathElm.getTotalLength();
    var pieceSize = pLength / 2;
    var _pathElm$getPointAtLe = pathElm.getPointAtLength(pieceSize),
      x = _pathElm$getPointAtLe.x,
      y = _pathElm$getPointAtLe.y;
    var angle = Math.atan2(x, y) * 180 / Math.PI;
    return {
      x: x,
      y: y,
      angle: angle
    };
  }
  /**
   * Get the angle for the path.
   */
  function getAngle(source, target) {
    var dx = source.x - target.x;
    var dy = source.y - target.y;
    var theta = Math.atan2(-dy, -dx);
    theta *= 180 / Math.PI;
    if (theta < 0) {
      theta += 360;
    }
    return theta;
  }
  /**
   * Get the center for the path element.
   */
  function getPathCenter(pathElm, firstPoint, lastPoint) {
    if (!pathElm) {
      return null;
    }
    var angle = getAngle(firstPoint, lastPoint);
    var point = getCenter(pathElm);
    return Object.assign(Object.assign({}, point), {
      angle: angle
    });
  }
  var css_248z$3 = ".Add-module_plus__30sKV {\n  stroke: black;\n  pointer-events: none;\n}\n\n.Add-module_container__1RcJg {\n  will-change: transform, opacity;\n}\n\n.Add-module_drop__W1fxu {\n  cursor: pointer;\n  opacity: 0;\n}\n\n.Add-module_rect__3JiVn {\n  shape-rendering: geometricPrecision;\n  fill: #46FECB;\n  border-radius: 2px;\n  pointer-events: none;\n}\n";
  var css$3 = {
    "plus": "Add-module_plus__30sKV",
    "container": "Add-module_container__1RcJg",
    "drop": "Add-module_drop__W1fxu",
    "rect": "Add-module_rect__3JiVn"
  };
  styleInject(css_248z$3);
  var Add = function Add(_ref16) {
    var x = _ref16.x,
      y = _ref16.y,
      className = _ref16.className,
      _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? 15 : _ref16$size,
      _ref16$hidden = _ref16.hidden,
      hidden = _ref16$hidden === void 0 ? true : _ref16$hidden,
      _ref16$onEnter = _ref16.onEnter,
      onEnter = _ref16$onEnter === void 0 ? function () {
        return undefined;
      } : _ref16$onEnter,
      _ref16$onLeave = _ref16.onLeave,
      onLeave = _ref16$onLeave === void 0 ? function () {
        return undefined;
      } : _ref16$onLeave,
      _ref16$onClick = _ref16.onClick,
      _onClick3 = _ref16$onClick === void 0 ? function () {
        return undefined;
      } : _ref16$onClick;
    if (hidden) {
      return null;
    }
    var half = size / 2;
    var translateX = x - half;
    var translateY = y - half;
    return jsxRuntime.jsxs(framerMotion.motion.g, Object.assign({
      className: classNames__default['default'](className, css$3.container),
      initial: {
        scale: 0,
        opacity: 0,
        translateX: translateX,
        translateY: translateY
      },
      animate: {
        scale: 1,
        opacity: 1,
        translateX: translateX,
        translateY: translateY
      },
      whileHover: {
        scale: 1.2
      },
      whileTap: {
        scale: 0.8
      }
    }, {
      children: [jsxRuntime.jsx("rect", {
        height: size * 2,
        width: size * 2,
        className: css$3.drop,
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          _onClick3(event);
        },
        onMouseEnter: onEnter,
        onMouseLeave: onLeave
      }, void 0), jsxRuntime.jsx("rect", {
        height: size,
        width: size,
        className: css$3.rect
      }, void 0), jsxRuntime.jsx("line", {
        x1: "2",
        x2: size - 2,
        y1: half,
        y2: half,
        className: css$3.plus,
        strokeWidth: "1"
      }, void 0), jsxRuntime.jsx("line", {
        x1: half,
        x2: half,
        y1: "2",
        y2: size - 2,
        className: css$3.plus,
        strokeWidth: "1"
      }, void 0)]
    }), void 0);
  };
  var css_248z$4 = ".Edge-module_edge__RbmGh.Edge-module_disabled__20Zof {\n    pointer-events: none;\n  }\n  .Edge-module_edge__RbmGh:not(.Edge-module_selectionDisabled__MVwAS):not(.Edge-module_disabled__20Zof):hover .Edge-module_path__u3LT2 {\n        stroke: #a5a9e2;\n      }\n  .Edge-module_edge__RbmGh:not(.Edge-module_selectionDisabled__MVwAS):not(.Edge-module_disabled__20Zof):hover .Edge-module_path__u3LT2.Edge-module_active__2dt5E {\n          stroke: #46fecb;\n        }\n  .Edge-module_edge__RbmGh:not(.Edge-module_selectionDisabled__MVwAS):not(.Edge-module_disabled__20Zof):hover .Edge-module_path__u3LT2.Edge-module_deleteHovered__ZG2og {\n          stroke: #ff005d;\n          stroke-dasharray: 4 2;\n        }\n  .Edge-module_edge__RbmGh:not(.Edge-module_selectionDisabled__MVwAS):not(.Edge-module_disabled__20Zof) .Edge-module_clicker__3cdd0 {\n      cursor: pointer;\n    }\n\n.Edge-module_path__u3LT2 {\n  fill: transparent;\n  stroke: #485a74;\n  pointer-events: none;\n  shape-rendering: geometricPrecision;\n  stroke-width: 1pt;\n}\n\n.Edge-module_clicker__3cdd0 {\n  fill: none;\n  stroke: transparent;\n  stroke-width: 15px;\n}\n\n.Edge-module_clicker__3cdd0:focus {\n    outline: none;\n  }\n";
  var css$4 = {
    "edge": "Edge-module_edge__RbmGh",
    "disabled": "Edge-module_disabled__20Zof",
    "selectionDisabled": "Edge-module_selectionDisabled__MVwAS",
    "path": "Edge-module_path__u3LT2",
    "active": "Edge-module_active__2dt5E",
    "deleteHovered": "Edge-module_deleteHovered__ZG2og",
    "clicker": "Edge-module_clicker__3cdd0"
  };
  styleInject(css_248z$4);
  var Edge = function Edge(_ref17) {
    var sections = _ref17.sections,
      properties = _ref17.properties,
      labels = _ref17.labels,
      className = _ref17.className,
      containerClassName = _ref17.containerClassName,
      disabled = _ref17.disabled,
      _ref17$removable = _ref17.removable,
      removable = _ref17$removable === void 0 ? true : _ref17$removable,
      _ref17$selectable = _ref17.selectable,
      selectable = _ref17$selectable === void 0 ? true : _ref17$selectable,
      _ref17$upsertable = _ref17.upsertable,
      upsertable = _ref17$upsertable === void 0 ? true : _ref17$upsertable,
      style = _ref17.style,
      children = _ref17.children,
      _ref17$add = _ref17.add,
      add = _ref17$add === void 0 ? jsxRuntime.jsx(Add, {}, void 0) : _ref17$add,
      _ref17$remove = _ref17.remove,
      remove = _ref17$remove === void 0 ? jsxRuntime.jsx(Remove, {}, void 0) : _ref17$remove,
      _ref17$label = _ref17.label,
      label = _ref17$label === void 0 ? jsxRuntime.jsx(Label, {}, void 0) : _ref17$label,
      _ref17$onClick = _ref17.onClick,
      _onClick4 = _ref17$onClick === void 0 ? function () {
        return undefined;
      } : _ref17$onClick,
      _ref17$onKeyDown = _ref17.onKeyDown,
      _onKeyDown = _ref17$onKeyDown === void 0 ? function () {
        return undefined;
      } : _ref17$onKeyDown,
      _ref17$onEnter = _ref17.onEnter,
      onEnter = _ref17$onEnter === void 0 ? function () {
        return undefined;
      } : _ref17$onEnter,
      _ref17$onLeave = _ref17.onLeave,
      onLeave = _ref17$onLeave === void 0 ? function () {
        return undefined;
      } : _ref17$onLeave,
      _ref17$onRemove = _ref17.onRemove,
      onRemove = _ref17$onRemove === void 0 ? function () {
        return undefined;
      } : _ref17$onRemove,
      _ref17$onAdd = _ref17.onAdd,
      onAdd = _ref17$onAdd === void 0 ? function () {
        return undefined;
      } : _ref17$onAdd;
    var pathRef = react.useRef(null);
    var _react$useState25 = react.useState(false),
      _react$useState26 = _slicedToArray(_react$useState25, 2),
      deleteHovered = _react$useState26[0],
      setDeleteHovered = _react$useState26[1];
    var _react$useState27 = react.useState(null),
      _react$useState28 = _slicedToArray(_react$useState27, 2),
      center = _react$useState28[0],
      setCenter = _react$useState28[1];
    var _useCanvas3 = useCanvas(),
      selections = _useCanvas3.selections,
      readonly = _useCanvas3.readonly;
    var isActive = (selections === null || selections === void 0 ? void 0 : selections.length) ? selections.includes(properties === null || properties === void 0 ? void 0 : properties.id) : false;
    var isDisabled = disabled || (properties === null || properties === void 0 ? void 0 : properties.disabled);
    var canSelect = selectable && !(properties === null || properties === void 0 ? void 0 : properties.selectionDisabled);
    // The "d" attribute defines a path to be drawn. See https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d
    var d = react.useMemo(function () {
      if (!(sections === null || sections === void 0 ? void 0 : sections.length)) {
        return null;
      }
      // Handle bend points that elk gives
      // us separately from drag points
      if (sections[0].bendPoints) {
        var points = sections ? [sections[0].startPoint].concat(_toConsumableArray(sections[0].bendPoints || []), [sections[0].endPoint]) : [];
        var pathFn = d3Shape.line().x(function (d) {
          return d.x;
        }).y(function (d) {
          return d.y;
        }).curve(d3Shape.curveBundle.beta(1));
        return pathFn(points);
      } else {
        return getBezierPath({
          sourceX: sections[0].startPoint.x,
          sourceY: sections[0].startPoint.y,
          targetX: sections[0].endPoint.x,
          targetY: sections[0].endPoint.y
        });
      }
    }, [sections]);
    react.useEffect(function () {
      if ((sections === null || sections === void 0 ? void 0 : sections.length) > 0) {
        setCenter(getPathCenter(pathRef.current, sections[0].startPoint, sections[0].endPoint));
      }
    }, [sections]);
    var edgeChildProps = {
      edge: properties,
      center: center,
      pathRef: pathRef
    };
    return jsxRuntime.jsxs("g", Object.assign({
      className: classNames__default['default'](css$4.edge, containerClassName, _defineProperty(_defineProperty({}, css$4.disabled, isDisabled), css$4.selectionDisabled, !canSelect))
    }, {
      children: [jsxRuntime.jsx("path", {
        ref: pathRef,
        style: style,
        className: classNames__default['default'](css$4.path, properties === null || properties === void 0 ? void 0 : properties.className, className, _defineProperty(_defineProperty({}, css$4.active, isActive), css$4.deleteHovered, deleteHovered)),
        d: d,
        markerEnd: "url(#end-arrow)"
      }, void 0), jsxRuntime.jsx("path", {
        className: css$4.clicker,
        d: d,
        tabIndex: -1,
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          if (!isDisabled && canSelect) {
            _onClick4(event, properties);
          }
        },
        onKeyDown: function onKeyDown(event) {
          event.preventDefault();
          event.stopPropagation();
          if (!isDisabled) {
            _onKeyDown(event, properties);
          }
        },
        onMouseEnter: function onMouseEnter(event) {
          event.stopPropagation();
          if (!isDisabled) {
            onEnter(event, properties);
          }
        },
        onMouseLeave: function onMouseLeave(event) {
          event.stopPropagation();
          if (!isDisabled) {
            onLeave(event, properties);
          }
        }
      }, void 0), children && jsxRuntime.jsx(react.Fragment, {
        children: typeof children === 'function' ? children(edgeChildProps) : children
      }, void 0), (labels === null || labels === void 0 ? void 0 : labels.length) > 0 && labels.map(function (l, index) {
        return jsxRuntime.jsx(rdk.CloneElement, Object.assign({
          element: label
        }, l), index);
      }), !isDisabled && center && !readonly && remove && removable && jsxRuntime.jsx(rdk.CloneElement, Object.assign({
        element: remove
      }, center, {
        hidden: remove.props.hidden !== undefined ? remove.props.hidden : !isActive,
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          onRemove(event, properties);
          setDeleteHovered(false);
        },
        onEnter: function onEnter() {
          return setDeleteHovered(true);
        },
        onLeave: function onLeave() {
          return setDeleteHovered(false);
        }
      }), void 0), !isDisabled && center && !readonly && add && upsertable && jsxRuntime.jsx(rdk.CloneElement, Object.assign({
        element: add
      }, center, {
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          onAdd(event, properties);
        }
      }), void 0)]
    }), void 0);
  };
  var css_248z$5 = ".Node-module_rect__1Eal3 {\n  fill: #2b2c3e;\n  transition: stroke 100ms ease-in-out;\n  stroke: #475872;\n  shape-rendering: geometricPrecision;\n  stroke-width: 1pt;\n}\n\n  .Node-module_rect__1Eal3:not(.Node-module_selectionDisabled__2zufG):not(.Node-module_disabled__bZzf8) {\n    cursor: pointer;\n  }\n\n  .Node-module_rect__1Eal3:not(.Node-module_selectionDisabled__2zufG):not(.Node-module_disabled__bZzf8):hover {\n      stroke: #a5a9e2;\n    }\n\n  .Node-module_rect__1Eal3:not(.Node-module_selectionDisabled__2zufG):not(.Node-module_disabled__bZzf8).Node-module_dragging__24Avg {\n      stroke: #a5a9e2;\n    }\n\n  .Node-module_rect__1Eal3:not(.Node-module_selectionDisabled__2zufG):not(.Node-module_disabled__bZzf8).Node-module_active__1b2HC {\n      stroke: #46fecb;\n    }\n\n  .Node-module_rect__1Eal3:not(.Node-module_selectionDisabled__2zufG):not(.Node-module_disabled__bZzf8).Node-module_unlinkable__p6w5x {\n      stroke: #ff005d;\n    }\n\n  .Node-module_rect__1Eal3:not(.Node-module_selectionDisabled__2zufG):not(.Node-module_disabled__bZzf8).Node-module_deleteHovered__36-dV {\n      stroke: #ff005d !important;\n      stroke-dasharray: 4 2;\n    }\n\n  .Node-module_rect__1Eal3:focus {\n    outline: none;\n  }\n\n  .Node-module_rect__1Eal3.Node-module_children__1kq65 {\n    fill: transparent;\n    stroke: #475872;\n  }\n";
  var css$5 = {
    "rect": "Node-module_rect__1Eal3",
    "selectionDisabled": "Node-module_selectionDisabled__2zufG",
    "disabled": "Node-module_disabled__bZzf8",
    "dragging": "Node-module_dragging__24Avg",
    "active": "Node-module_active__1b2HC",
    "unlinkable": "Node-module_unlinkable__p6w5x",
    "deleteHovered": "Node-module_deleteHovered__36-dV",
    "children": "Node-module_children__1kq65"
  };
  styleInject(css_248z$5);
  var _Node = function Node(_ref18) {
    var id = _ref18.id,
      x = _ref18.x,
      y = _ref18.y,
      ports = _ref18.ports,
      labels = _ref18.labels,
      height = _ref18.height,
      width = _ref18.width,
      properties = _ref18.properties,
      animated = _ref18.animated,
      className = _ref18.className,
      _ref18$rx = _ref18.rx,
      rx = _ref18$rx === void 0 ? 2 : _ref18$rx,
      _ref18$ry = _ref18.ry,
      ry = _ref18$ry === void 0 ? 2 : _ref18$ry,
      _ref18$offsetX = _ref18.offsetX,
      offsetX = _ref18$offsetX === void 0 ? 0 : _ref18$offsetX,
      _ref18$offsetY = _ref18.offsetY,
      offsetY = _ref18$offsetY === void 0 ? 0 : _ref18$offsetY,
      icon = _ref18.icon,
      disabled = _ref18.disabled,
      style = _ref18.style,
      children = _ref18.children,
      nodes = _ref18.nodes,
      edges = _ref18.edges,
      _ref18$draggable = _ref18.draggable,
      draggable = _ref18$draggable === void 0 ? true : _ref18$draggable,
      _ref18$linkable = _ref18.linkable,
      linkable = _ref18$linkable === void 0 ? true : _ref18$linkable,
      _ref18$selectable = _ref18.selectable,
      selectable = _ref18$selectable === void 0 ? true : _ref18$selectable,
      _ref18$removable = _ref18.removable,
      removable = _ref18$removable === void 0 ? true : _ref18$removable,
      _ref18$dragType = _ref18.dragType,
      dragType = _ref18$dragType === void 0 ? 'multiportOnly' : _ref18$dragType,
      _ref18$dragCursor = _ref18.dragCursor,
      dragCursor = _ref18$dragCursor === void 0 ? 'crosshair' : _ref18$dragCursor,
      _ref18$childEdge = _ref18.childEdge,
      childEdge = _ref18$childEdge === void 0 ? jsxRuntime.jsx(Edge, {}, void 0) : _ref18$childEdge,
      _ref18$childNode = _ref18.childNode,
      childNode = _ref18$childNode === void 0 ? jsxRuntime.jsx(_Node, {}, void 0) : _ref18$childNode,
      _ref18$remove = _ref18.remove,
      remove = _ref18$remove === void 0 ? jsxRuntime.jsx(Remove, {}, void 0) : _ref18$remove,
      _ref18$port = _ref18.port,
      port = _ref18$port === void 0 ? jsxRuntime.jsx(Port, {}, void 0) : _ref18$port,
      _ref18$label = _ref18.label,
      label = _ref18$label === void 0 ? jsxRuntime.jsx(Label, {}, void 0) : _ref18$label,
      onRemove = _ref18.onRemove,
      _onDrag = _ref18.onDrag,
      _onDragStart = _ref18.onDragStart,
      _onDragEnd = _ref18.onDragEnd,
      onClick = _ref18.onClick,
      onKeyDown = _ref18.onKeyDown,
      onEnter = _ref18.onEnter,
      onLeave = _ref18.onLeave;
    var nodeRef = react.useRef(null);
    var controls = framerMotion.useAnimation();
    var _a = useCanvas(),
      canLinkNode = _a.canLinkNode,
      enteredNode = _a.enteredNode,
      selections = _a.selections,
      readonly = _a.readonly,
      canvas = __rest(_a, ["canLinkNode", "enteredNode", "selections", "readonly"]);
    var _react$useState29 = react.useState(false),
      _react$useState30 = _slicedToArray(_react$useState29, 2),
      deleteHovered = _react$useState30[0],
      setDeleteHovered = _react$useState30[1];
    var _react$useState31 = react.useState(false),
      _react$useState32 = _slicedToArray(_react$useState31, 2),
      dragging = _react$useState32[0],
      setDragging = _react$useState32[1];
    var _react$useState33 = react.useState(true),
      _react$useState34 = _slicedToArray(_react$useState33, 2),
      isLinkable = _react$useState34[0],
      setIsLinkable = _react$useState34[1];
    var isActive = (selections === null || selections === void 0 ? void 0 : selections.length) ? selections.includes(properties.id) : null;
    var isNodeDrag = id.includes('node-drag');
    var newX = x + offsetX;
    var newY = y + offsetY;
    var isMultiPort = dragType === 'multiportOnly' && (ports === null || ports === void 0 ? void 0 : ports.filter(function (p) {
      var _a;
      return !((_a = p.properties) === null || _a === void 0 ? void 0 : _a.hidden);
    }).length) > 1;
    var isDisabled = disabled || (properties === null || properties === void 0 ? void 0 : properties.disabled);
    var canDrag = ['port', 'multiportOnly'].includes(dragType) ? linkable : draggable;
    var canSelect = selectable && !(properties === null || properties === void 0 ? void 0 : properties.selectionDisabled);
    var getDragType = react.useCallback(function (hasPort) {
      var activeDragType = null;
      if (!hasPort) {
        if (dragType === 'all' || dragType === 'node') {
          activeDragType = 'node';
        } else if (!isMultiPort) {
          activeDragType = 'port';
        }
      } else {
        if (dragType === 'all' || dragType === 'port' || isMultiPort) {
          activeDragType = 'port';
        }
      }
      return activeDragType;
    }, [dragType, isMultiPort]);
    var setDragCursor = react.useCallback(function (dragType) {
      if (dragType) {
        document.body.classList.add('dragging');
        document.body.style.cursor = dragType === 'node' ? 'grab' : 'crosshair';
      } else {
        document.body.classList.remove('dragging');
        document.body.style.cursor = 'auto';
      }
    }, []);
    var bind = useNodeDrag({
      x: newX,
      y: newY,
      height: height,
      width: width,
      disabled: isDisabled || isMultiPort || readonly || !canDrag || dragType === 'port',
      node: properties,
      onDrag: function onDrag() {
        if (!isDisabled && canDrag) {
          canvas.onDrag.apply(canvas, arguments);
          _onDrag === null || _onDrag === void 0 ? void 0 : _onDrag.apply(void 0, arguments);
        }
      },
      onDragStart: function onDragStart(event, coords, node, port) {
        if (!isDisabled && canDrag) {
          // @ts-ignore
          event.dragType = getDragType(false);
          // @ts-ignore
          setDragCursor(event.dragType);
          canvas.onDragStart(event, coords, node, port);
          _onDragStart === null || _onDragStart === void 0 ? void 0 : _onDragStart(event, coords, node, port);
          setDragging(true);
        }
      },
      onDragEnd: function onDragEnd(event, coords, node, port) {
        if (!isDisabled && canDrag) {
          // @ts-ignore
          event.dragType = getDragType(false);
          // @ts-ignore
          event.srcElement = nodeRef.current;
          canvas.onDragEnd(event, coords, node, port);
          _onDragEnd === null || _onDragEnd === void 0 ? void 0 : _onDragEnd(event, coords, node, port);
          setDragging(false);
          setDragCursor(null);
        }
      }
    });
    react.useEffect(function () {
      if ((enteredNode === null || enteredNode === void 0 ? void 0 : enteredNode.id) === properties.id) {
        setIsLinkable(checkNodeLinkable(properties, enteredNode, canLinkNode));
      }
      return function () {
        return setIsLinkable(true);
      };
    }, [canLinkNode, enteredNode, properties]);
    react.useEffect(function () {
      controls.set({
        opacity: 1,
        translateX: x,
        translateY: y
      });
    }, [controls, x, y]);
    var nodeChildProps = {
      height: height,
      width: width,
      x: x,
      y: y,
      node: properties,
      nodes: nodes,
      edges: edges
    };
    var onClickCallback = react.useCallback(function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (!isDisabled && canSelect) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event, properties);
      }
    }, [canSelect, isDisabled, onClick, properties]);
    var onKeyDownCallback = react.useCallback(function (event) {
      event.preventDefault();
      if (!isDisabled) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event, properties);
      }
    }, [isDisabled, onKeyDown, properties]);
    var onTouchStartCallback = react.useCallback(function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, []);
    var onMouseEnterCallback = react.useCallback(function (event) {
      event.stopPropagation();
      canvas.onEnter(event, properties);
      if (!isDisabled) {
        onEnter === null || onEnter === void 0 ? void 0 : onEnter(event, properties);
      }
    }, [canvas, isDisabled, onEnter, properties]);
    var onMouseLeaveCallback = react.useCallback(function (event) {
      event.stopPropagation();
      canvas.onLeave(event, properties);
      if (!isDisabled) {
        onLeave === null || onLeave === void 0 ? void 0 : onLeave(event, properties);
      }
    }, [canvas, isDisabled, onLeave, properties]);
    var onDragStartCallback = react.useCallback(function (event, initial, data) {
      if (!isDisabled && linkable) {
        // @ts-ignore
        event.dragType = getDragType(true);
        // @ts-ignore
        setDragCursor(event.dragType);
        canvas.onDragStart(event, initial, properties, data);
        _onDragStart === null || _onDragStart === void 0 ? void 0 : _onDragStart(event, initial, properties, data);
        setDragging(true);
      }
    }, [canvas, getDragType, isDisabled, linkable, _onDragStart, properties, setDragCursor]);
    var onDragCallback = react.useCallback(function (event, initial, data) {
      if (!isDisabled && linkable) {
        canvas.onDrag(event, initial, properties, data);
        _onDrag === null || _onDrag === void 0 ? void 0 : _onDrag(event, initial, properties, data);
      }
    }, [canvas, isDisabled, linkable, _onDrag, properties]);
    var onDragEndCallback = react.useCallback(function (event, initial, data) {
      if (!isDisabled && linkable) {
        // @ts-ignore
        event.dragType = getDragType(true);
        setDragCursor(null);
        canvas.onDragEnd(event, initial, properties, data);
        _onDragEnd === null || _onDragEnd === void 0 ? void 0 : _onDragEnd(event, initial, properties, data);
        setDragging(false);
      }
    }, [canvas, getDragType, isDisabled, linkable, _onDragEnd, properties, setDragCursor]);
    return jsxRuntime.jsxs(framerMotion.motion.g, Object.assign({
      id: id,
      initial: {
        cursor: 'initial',
        opacity: 0,
        translateX: x,
        translateY: y
      },
      animate: controls
    }, {
      children: [jsxRuntime.jsx(framerMotion.motion.rect, Object.assign({}, bind(), {
        ref: nodeRef,
        tabIndex: -1,
        onKeyDown: onKeyDownCallback,
        onClick: onClickCallback,
        onTouchStart: onTouchStartCallback,
        onMouseEnter: onMouseEnterCallback,
        onMouseLeave: onMouseLeaveCallback,
        className: classNames__default['default'](css$5.rect, className, properties === null || properties === void 0 ? void 0 : properties.className, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, css$5.active, isActive), css$5.disabled, isDisabled), css$5.unlinkable, isLinkable === false && !isNodeDrag), css$5.dragging, dragging), css$5.children, (nodes === null || nodes === void 0 ? void 0 : nodes.length) > 0), css$5.deleteHovered, deleteHovered), css$5.selectionDisabled, !canSelect)),
        style: style,
        height: height,
        width: width,
        rx: rx,
        ry: ry,
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1,
          transition: !animated ? {
            type: false,
            duration: 0
          } : {}
        }
      }), void 0), children && jsxRuntime.jsx(react.Fragment, {
        children: typeof children === 'function' ? children(nodeChildProps) : children
      }, void 0), icon && properties.icon && jsxRuntime.jsx(rdk.CloneElement, Object.assign({
        element: icon
      }, properties.icon), void 0), label && (labels === null || labels === void 0 ? void 0 : labels.length) > 0 && labels.map(function (l, index) {
        return jsxRuntime.jsx(rdk.CloneElement, Object.assign({
          element: label
        }, l), index);
      }), port && (ports === null || ports === void 0 ? void 0 : ports.length) > 0 && ports.map(function (p) {
        return jsxRuntime.jsx(rdk.CloneElement, Object.assign({
          element: port,
          active: !isMultiPort && dragging,
          disabled: isDisabled || !linkable,
          offsetX: newX,
          offsetY: newY,
          onDragStart: onDragStartCallback,
          onDrag: onDragCallback,
          onDragEnd: onDragEndCallback
        }, p, {
          id: "".concat(id, "-port-").concat(p.id)
        }), p.id);
      }), !isDisabled && isActive && !readonly && remove && removable && jsxRuntime.jsx(rdk.CloneElement, {
        element: remove,
        y: height / 2,
        x: width,
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();
          onRemove === null || onRemove === void 0 ? void 0 : onRemove(event, properties);
          setDeleteHovered(false);
        },
        onEnter: function onEnter() {
          return setDeleteHovered(true);
        },
        onLeave: function onLeave() {
          return setDeleteHovered(false);
        }
      }, void 0), jsxRuntime.jsxs("g", {
        children: [(edges === null || edges === void 0 ? void 0 : edges.length) > 0 && edges.map(function (e) {
          var element = typeof childEdge === 'function' ? childEdge(e) : childEdge;
          return jsxRuntime.jsx(rdk.CloneElement, Object.assign({
            element: element,
            id: "".concat(id, "-edge-").concat(e.id),
            disabled: isDisabled
          }, e, {
            properties: Object.assign(Object.assign({}, e.properties), e.data ? {
              data: e.data
            } : {})
          }), e.id);
        }), (nodes === null || nodes === void 0 ? void 0 : nodes.length) > 0 && nodes.map(function (_a) {
          var _b, _c, _d, _e, _f, _g;
          var children = _a.children,
            n = __rest(_a, ["children"]);
          var element = typeof childNode === 'function' ? childNode(n) : childNode;
          var elementDisabled = ((_b = element.props) === null || _b === void 0 ? void 0 : _b.disabled) != null ? element.props.disabled : disabled;
          var elementAnimated = ((_c = element.props) === null || _c === void 0 ? void 0 : _c.animated) != null ? element.props.animated : animated;
          var elementDraggable = ((_d = element.props) === null || _d === void 0 ? void 0 : _d.draggable) != null ? element.props.draggable : draggable;
          var elementLinkable = ((_e = element.props) === null || _e === void 0 ? void 0 : _e.linkable) != null ? element.props.linkable : linkable;
          var elementSelectable = ((_f = element.props) === null || _f === void 0 ? void 0 : _f.selectable) != null ? element.props.selectable : selectable;
          var elementRemovable = ((_g = element.props) === null || _g === void 0 ? void 0 : _g.removable) != null ? element.props.removable : removable;
          return jsxRuntime.jsx(rdk.CloneElement, Object.assign({
            element: element,
            id: "".concat(id, "-node-").concat(n.id),
            disabled: elementDisabled,
            nodes: children,
            offsetX: newX,
            offsetY: newY,
            animated: elementAnimated,
            children: element.props.children,
            childNode: childNode,
            dragCursor: dragCursor,
            dragType: dragType,
            childEdge: childEdge,
            draggable: elementDraggable,
            linkable: elementLinkable,
            selectable: elementSelectable,
            removable: elementRemovable,
            onDragStart: _onDragStart,
            onDrag: _onDrag,
            onDragEnd: _onDragEnd,
            onClick: onClick,
            onEnter: onEnter,
            onLeave: onLeave,
            onKeyDown: onKeyDown,
            onRemove: onRemove
          }, n), n.id);
        })]
      }, void 0)]
    }), void 0);
  };
  var css_248z$6 = ".Arrow-module_arrow__aEgOT {\n  pointer-events: none;\n  shape-rendering: geometricPrecision;\n  fill: #485a74;\n}\n";
  var css$6 = {
    "arrow": "Arrow-module_arrow__aEgOT"
  };
  styleInject(css_248z$6);
  var Arrow = function Arrow(_ref19) {
    var _ref19$size = _ref19.size,
      size = _ref19$size === void 0 ? 8 : _ref19$size,
      _ref19$y = _ref19.y,
      y = _ref19$y === void 0 ? 0 : _ref19$y,
      _ref19$x = _ref19.x,
      x = _ref19$x === void 0 ? 0 : _ref19$x,
      _ref19$angle = _ref19.angle,
      angle = _ref19$angle === void 0 ? 0 : _ref19$angle,
      className = _ref19.className,
      style = _ref19.style;
    return jsxRuntime.jsx("path", {
      style: style,
      transform: "translate(".concat(x, ", ").concat(y, ") rotate(").concat(angle, ")"),
      className: classNames__default['default'](css$6.arrow, className),
      d: "M0,-".concat(size / 2, "L").concat(size, ",0L0,").concat(size / 2)
    }, void 0);
  };
  var MarkerArrow = function MarkerArrow(_ref20) {
    var _ref20$size = _ref20.size,
      size = _ref20$size === void 0 ? 8 : _ref20$size,
      className = _ref20.className,
      style = _ref20.style;
    return jsxRuntime.jsx("marker", Object.assign({
      id: "end-arrow",
      viewBox: "0 -".concat(size / 2, " ").concat(size, " ").concat(size),
      refX: "".concat(size),
      markerWidth: "".concat(size),
      markerHeight: "".concat(size),
      orient: "auto"
    }, {
      children: jsxRuntime.jsx(Arrow, {
        size: size,
        style: style,
        className: className
      }, void 0)
    }), "end-arrow");
  };
  var css_248z$7 = ".Canvas-module_container__22cN4.Canvas-module_pannable__1d7xd {\n    overflow: auto;\n  }\n  .Canvas-module_container__22cN4:focus {\n    outline: none;\n  }\n\n.dragging {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.Canvas-module_dragNode__2q6bP {\n  pointer-events: none;\n}\n";
  var css$7 = {
    "container": "Canvas-module_container__22cN4",
    "pannable": "Canvas-module_pannable__1d7xd",
    "dragNode": "Canvas-module_dragNode__2q6bP"
  };
  styleInject(css_248z$7);
  var InternalCanvas = react.forwardRef(function (_ref21, ref) {
    var className = _ref21.className,
      _ref21$height = _ref21.height,
      height = _ref21$height === void 0 ? '100%' : _ref21$height,
      _ref21$width = _ref21.width,
      width = _ref21$width === void 0 ? '100%' : _ref21$width,
      readonly = _ref21.readonly,
      _ref21$disabled = _ref21.disabled,
      disabled = _ref21$disabled === void 0 ? false : _ref21$disabled,
      _ref21$animated = _ref21.animated,
      animated = _ref21$animated === void 0 ? true : _ref21$animated,
      _ref21$arrow = _ref21.arrow,
      arrow = _ref21$arrow === void 0 ? jsxRuntime.jsx(MarkerArrow, {}, void 0) : _ref21$arrow,
      _ref21$node = _ref21.node,
      node = _ref21$node === void 0 ? jsxRuntime.jsx(_Node, {}, void 0) : _ref21$node,
      _ref21$edge = _ref21.edge,
      edge = _ref21$edge === void 0 ? jsxRuntime.jsx(Edge, {}, void 0) : _ref21$edge,
      _ref21$dragNode = _ref21.dragNode,
      dragNode = _ref21$dragNode === void 0 ? jsxRuntime.jsx(_Node, {}, void 0) : _ref21$dragNode,
      _ref21$dragEdge = _ref21.dragEdge,
      dragEdge = _ref21$dragEdge === void 0 ? jsxRuntime.jsx(Edge, {
        add: null
      }, void 0) : _ref21$dragEdge,
      _ref21$onMouseEnter = _ref21.onMouseEnter,
      onMouseEnter = _ref21$onMouseEnter === void 0 ? function () {
        return undefined;
      } : _ref21$onMouseEnter,
      _ref21$onMouseLeave = _ref21.onMouseLeave,
      onMouseLeave = _ref21$onMouseLeave === void 0 ? function () {
        return undefined;
      } : _ref21$onMouseLeave,
      _ref21$onCanvasClick = _ref21.onCanvasClick,
      onCanvasClick = _ref21$onCanvasClick === void 0 ? function () {
        return undefined;
      } : _ref21$onCanvasClick;
    var _a, _b, _c, _d, _e;
    var id = rdk.useId();
    var _f = useCanvas(),
      pannable = _f.pannable,
      dragCoords = _f.dragCoords,
      canvasDragNode = _f.dragNode,
      layout = _f.layout,
      containerRef = _f.containerRef,
      svgRef = _f.svgRef,
      canvasHeight = _f.canvasHeight,
      canvasWidth = _f.canvasWidth,
      xy = _f.xy,
      zoom = _f.zoom,
      setZoom = _f.setZoom,
      observe = _f.observe,
      zoomIn = _f.zoomIn,
      zoomOut = _f.zoomOut,
      centerCanvas = _f.centerCanvas,
      fitCanvas = _f.fitCanvas,
      rest = __rest(_f, ["pannable", "dragCoords", "dragNode", "layout", "containerRef", "svgRef", "canvasHeight", "canvasWidth", "xy", "zoom", "setZoom", "observe", "zoomIn", "zoomOut", "centerCanvas", "fitCanvas"]);
    var _react$useState35 = react.useState(null),
      _react$useState36 = _slicedToArray(_react$useState35, 2),
      dragType = _react$useState36[0],
      setDragType = _react$useState36[1];
    react.useImperativeHandle(ref, function () {
      return Object.assign(Object.assign({}, rest), {
        observe: observe,
        zoom: zoom,
        xy: xy,
        layout: layout,
        canvasHeight: canvasHeight,
        containerRef: containerRef,
        canvasWidth: canvasWidth,
        svgRef: svgRef,
        centerCanvas: centerCanvas,
        setZoom: setZoom,
        zoomIn: zoomIn,
        zoomOut: zoomOut,
        fitCanvas: fitCanvas
      });
    });
    var mount = react.useRef(false);
    var dragNodeData = react.useMemo(function () {
      return getDragNodeData(canvasDragNode, layout === null || layout === void 0 ? void 0 : layout.children);
    }, [canvasDragNode, layout === null || layout === void 0 ? void 0 : layout.children]);
    var _react$useState37 = react.useState(dragNodeData),
      _react$useState38 = _slicedToArray(_react$useState37, 2),
      dragNodeDataWithChildren = _react$useState38[0],
      setDragNodeDataWithChildren = _react$useState38[1];
    var dragNodeElement = react.useMemo(function () {
      return typeof dragNode === 'function' ? dragNode(dragNodeData) : dragNode;
    }, [dragNode, dragNodeData]);
    react.useLayoutEffect(function () {
      if (!mount.current && layout !== null && xy[0] > 0 && xy[1] > 0) {
        mount.current = true;
      }
    }, [layout, xy]);
    var onDragStart = react.useCallback(function (event) {
      setDragType(event.dragType);
    }, []);
    var createDragNodeChildren = react.useCallback(function (children) {
      if (!children || !Array.isArray(children)) {
        return [];
      }
      return children.map(function (_a) {
        var children = _a.children,
          n = __rest(_a, ["children"]);
        var element = typeof dragNode === 'function' ? dragNode(n) : dragNode;
        return jsxRuntime.jsx(rdk.CloneElement, Object.assign({
          element: element,
          disabled: true,
          children: element.props.children,
          animated: animated,
          nodes: children,
          childEdge: dragEdge,
          childNode: dragNode
        }, n, {
          onDragStart: onDragStart,
          id: "".concat(id, "-node-").concat(n.id, "-node-drag")
        }), "".concat(id, "-node-").concat(n.id, "-node-drag"));
      });
    },
    // Passing in dragEdge (JSX) will cause the function to be recalculated constantly,
    // triggering the below useEffect. Since dragEdge and dragNode are passed in props
    // on Canvas, they are unlikely to change and can be ignored
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [animated, id]);
    react.useEffect(function () {
      if (dragNodeData && Object.keys(dragNodeData).length > 0) {
        var nodeCopy = Object.assign({}, dragNodeData);
        // Node children is expecting a list of React Elements, need to create a list of elements
        nodeCopy.children = createDragNodeChildren(nodeCopy.children);
        setDragNodeDataWithChildren(nodeCopy);
      }
    }, [createDragNodeChildren, dragNodeData, layout === null || layout === void 0 ? void 0 : layout.children]);
    return jsxRuntime.jsx("div", Object.assign({
      style: {
        height: height,
        width: width
      },
      className: classNames__default['default'](css$7.container, className, _defineProperty({}, css$7.pannable, pannable)),
      ref: function ref(el) {
        // Really not a fan of this API change...
        // https://github.com/wellyshen/react-cool-dimensions#how-to-share-a-ref
        observe(el);
        // @ts-ignore
        containerRef.current = el;
      },
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, {
      children: jsxRuntime.jsxs("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        id: id,
        ref: svgRef,
        height: canvasHeight,
        width: canvasWidth,
        onClick: onCanvasClick
      }, {
        children: [arrow !== null && jsxRuntime.jsx("defs", {
          children: jsxRuntime.jsx(rdk.CloneElement, Object.assign({
            element: arrow
          }, arrow), void 0)
        }, void 0), jsxRuntime.jsxs(framerMotion.motion.g, Object.assign({
          initial: {
            opacity: 0,
            scale: 0,
            transition: {
              translateX: false,
              translateY: false
            }
          },
          animate: {
            opacity: 1,
            translateX: xy[0],
            translateY: xy[1],
            scale: zoom,
            transition: animated ? {
              velocity: 100,
              translateX: {
                duration: mount.current ? 0.3 : 0
              },
              translateY: {
                duration: mount.current ? 0.3 : 0
              },
              opacity: {
                duration: 0.8
              },
              when: 'beforeChildren'
            } : {
              type: false,
              duration: 0,
              when: 'beforeChildren'
            }
          }
        }, {
          children: [(_a = layout === null || layout === void 0 ? void 0 : layout.children) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
            var children = _a.children,
              n = __rest(_a, ["children"]);
            var element = typeof node === 'function' ? node(n) : node;
            return jsxRuntime.jsx(rdk.CloneElement, Object.assign({
              element: element,
              disabled: disabled,
              children: element.props.children,
              animated: animated,
              nodes: children,
              childEdge: edge,
              childNode: node
            }, n, {
              onDragStart: onDragStart,
              id: "".concat(id, "-node-").concat(n.id)
            }), n.id);
          }), (_b = layout === null || layout === void 0 ? void 0 : layout.edges) === null || _b === void 0 ? void 0 : _b.map(function (e) {
            var element = typeof edge === 'function' ? edge(e) : edge;
            return jsxRuntime.jsx(rdk.CloneElement, Object.assign({
              element: element,
              disabled: disabled,
              children: element.props.children
            }, e, {
              properties: Object.assign(Object.assign({}, e.properties), e.data ? {
                data: e.data
              } : {}),
              id: "".concat(id, "-edge-").concat(e.id)
            }), e.id);
          }), dragCoords !== null && dragEdge && dragType === 'port' && !readonly && jsxRuntime.jsx(rdk.CloneElement, {
            element: dragEdge,
            id: "".concat(id, "-edge-drag"),
            disabled: true,
            sections: dragCoords
          }, void 0), (_c = layout === null || layout === void 0 ? void 0 : layout.children) === null || _c === void 0 ? void 0 : _c.map(function (_a) {
            var children = _a.children,
              ports = _a.ports,
              n = __rest(_a, ["children", "ports"]);
            return jsxRuntime.jsx(react.Fragment, {
              children: (ports === null || ports === void 0 ? void 0 : ports.length) > 0 && jsxRuntime.jsx(framerMotion.motion.g, Object.assign({
                animate: {
                  translateX: n.x,
                  translateY: n.y,
                  transition: {
                    duration: 0
                  }
                }
              }, {
                children: ports.map(function (port, index) {
                  return jsxRuntime.jsx("use", {
                    xlinkHref: "#".concat(id, "-node-").concat(n.id, "-port-").concat(port.id),
                    style: {
                      pointerEvents: 'none'
                    }
                  }, index);
                })
              }), n.id)
            }, n.id);
          }), dragCoords !== null && dragNodeDataWithChildren && dragType === 'node' && !readonly && jsxRuntime.jsx(rdk.CloneElement, Object.assign({}, dragNodeDataWithChildren, {
            element: dragNodeElement,
            height: ((_d = dragNodeDataWithChildren === null || dragNodeDataWithChildren === void 0 ? void 0 : dragNodeDataWithChildren.props) === null || _d === void 0 ? void 0 : _d.height) || (dragNodeDataWithChildren === null || dragNodeDataWithChildren === void 0 ? void 0 : dragNodeDataWithChildren.height),
            width: ((_e = dragNodeDataWithChildren === null || dragNodeDataWithChildren === void 0 ? void 0 : dragNodeDataWithChildren.props) === null || _e === void 0 ? void 0 : _e.width) || (dragNodeDataWithChildren === null || dragNodeDataWithChildren === void 0 ? void 0 : dragNodeDataWithChildren.width),
            id: "".concat(id, "-node-drag"),
            animated: animated,
            className: css$7.dragNode,
            disabled: true,
            x: dragCoords[0].endPoint.x,
            y: dragCoords[0].endPoint.y
          }), void 0)]
        }), void 0)]
      }), void 0)
    }), void 0);
  });
  var Canvas = react.forwardRef(function (_a, ref) {
    var _a$selections = _a.selections,
      selections = _a$selections === void 0 ? [] : _a$selections,
      _a$readonly = _a.readonly,
      readonly = _a$readonly === void 0 ? false : _a$readonly,
      _a$fit = _a.fit,
      fit = _a$fit === void 0 ? false : _a$fit,
      _a$nodes = _a.nodes,
      nodes = _a$nodes === void 0 ? [] : _a$nodes,
      _a$edges = _a.edges,
      edges = _a$edges === void 0 ? [] : _a$edges,
      _a$maxHeight = _a.maxHeight,
      maxHeight = _a$maxHeight === void 0 ? 2000 : _a$maxHeight,
      _a$maxWidth = _a.maxWidth,
      maxWidth = _a$maxWidth === void 0 ? 2000 : _a$maxWidth,
      _a$direction = _a.direction,
      direction = _a$direction === void 0 ? 'DOWN' : _a$direction,
      _a$pannable = _a.pannable,
      pannable = _a$pannable === void 0 ? true : _a$pannable,
      _a$zoom = _a.zoom,
      zoom = _a$zoom === void 0 ? 1 : _a$zoom,
      _a$center = _a.center,
      center = _a$center === void 0 ? true : _a$center,
      _a$zoomable = _a.zoomable,
      zoomable = _a$zoomable === void 0 ? true : _a$zoomable,
      _a$minZoom = _a.minZoom,
      minZoom = _a$minZoom === void 0 ? -0.5 : _a$minZoom,
      _a$maxZoom = _a.maxZoom,
      maxZoom = _a$maxZoom === void 0 ? 1 : _a$maxZoom,
      _a$onNodeLink = _a.onNodeLink,
      onNodeLink = _a$onNodeLink === void 0 ? function () {
        return undefined;
      } : _a$onNodeLink,
      _a$onNodeLinkCheck = _a.onNodeLinkCheck,
      onNodeLinkCheck = _a$onNodeLinkCheck === void 0 ? function () {
        return undefined;
      } : _a$onNodeLinkCheck,
      _a$onLayoutChange = _a.onLayoutChange,
      onLayoutChange = _a$onLayoutChange === void 0 ? function () {
        return undefined;
      } : _a$onLayoutChange,
      _a$onZoomChange = _a.onZoomChange,
      onZoomChange = _a$onZoomChange === void 0 ? function () {
        return undefined;
      } : _a$onZoomChange,
      layoutOptions = _a.layoutOptions,
      rest = __rest(_a, ["selections", "readonly", "fit", "nodes", "edges", "maxHeight", "maxWidth", "direction", "pannable", "zoom", "center", "zoomable", "minZoom", "maxZoom", "onNodeLink", "onNodeLinkCheck", "onLayoutChange", "onZoomChange", "layoutOptions"]);
    return jsxRuntime.jsx(CanvasProvider, Object.assign({
      layoutOptions: layoutOptions,
      nodes: nodes,
      edges: edges,
      zoom: zoom,
      center: center,
      minZoom: minZoom,
      maxZoom: maxZoom,
      fit: fit,
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      direction: direction,
      pannable: pannable,
      zoomable: zoomable,
      readonly: readonly,
      onLayoutChange: onLayoutChange,
      selections: selections,
      onZoomChange: onZoomChange,
      onNodeLink: onNodeLink,
      onNodeLinkCheck: onNodeLinkCheck
    }, {
      children: jsxRuntime.jsx(InternalCanvas, Object.assign({
        ref: ref
      }, rest), void 0)
    }), void 0);
  });
  var css_248z$8 = ".Icon-module_icon__36fxL {\n  pointer-events: none;\n}\n";
  var css$8 = {
    "icon": "Icon-module_icon__36fxL"
  };
  styleInject(css_248z$8);
  var Icon = function Icon(_ref22) {
    var x = _ref22.x,
      y = _ref22.y,
      url = _ref22.url,
      style = _ref22.style,
      className = _ref22.className,
      _ref22$height = _ref22.height,
      height = _ref22$height === void 0 ? 40 : _ref22$height,
      _ref22$width = _ref22.width,
      width = _ref22$width === void 0 ? 40 : _ref22$width;
    return jsxRuntime.jsx("g", Object.assign({
      className: classNames__default['default'](css$8.icon, className),
      transform: "translate(".concat(x - width / 2, ", ").concat(y - height / 2, ")")
    }, {
      children: jsxRuntime.jsx("image", {
        style: style,
        xlinkHref: url,
        width: width,
        height: height
      }, void 0)
    }), void 0);
  };

  /**
   * Helper function for upserting a node in a edge.
   */
  function upsertNode(nodes, edges, edge, newNode) {
    var oldEdgeIndex = edges.findIndex(function (e) {
      return e.id === edge.id;
    });
    var edgeBeforeNewNode = Object.assign(Object.assign({}, edge), {
      id: "".concat(edge.from, "-").concat(newNode.id),
      to: newNode.id
    });
    var edgeAfterNewNode = Object.assign(Object.assign({}, edge), {
      id: "".concat(newNode.id, "-").concat(edge.to),
      from: newNode.id
    });
    if (edge.fromPort && edge.toPort) {
      edgeBeforeNewNode.fromPort = edge.fromPort;
      edgeBeforeNewNode.toPort = "".concat(newNode.id, "-to");
      edgeAfterNewNode.fromPort = "".concat(newNode.id, "-from");
      edgeAfterNewNode.toPort = edge.toPort;
    }
    edges.splice(oldEdgeIndex, 1, edgeBeforeNewNode, edgeAfterNewNode);
    return {
      nodes: [].concat(_toConsumableArray(nodes), [newNode]),
      edges: _toConsumableArray(edges)
    };
  }
  /**
   * Helper function for removing a node between edges and
   * linking the children.
   */
  function removeAndUpsertNodes(nodes, edges, removeNodes, onNodeLinkCheck) {
    if (!Array.isArray(removeNodes)) {
      removeNodes = [removeNodes];
    }
    var nodeIds = removeNodes.map(function (n) {
      return n.id;
    });
    var newNodes = nodes.filter(function (n) {
      return !nodeIds.includes(n.id);
    });
    var newEdges = edges.filter(function (e) {
      return !nodeIds.includes(e.from) && !nodeIds.includes(e.to);
    });
    var _iterator5 = _createForOfIteratorHelper(nodeIds),
      _step5;
    try {
      var _loop = function _loop() {
        var nodeId = _step5.value;
        var sourceEdges = edges.filter(function (e) {
          return e.to === nodeId;
        });
        var targetEdges = edges.filter(function (e) {
          return e.from === nodeId;
        });
        var _iterator6 = _createForOfIteratorHelper(sourceEdges),
          _step6;
        try {
          var _loop2 = function _loop2() {
            var sourceEdge = _step6.value;
            var _iterator7 = _createForOfIteratorHelper(targetEdges),
              _step7;
            try {
              var _loop3 = function _loop3() {
                var targetEdge = _step7.value;
                var sourceNode = nodes.find(function (n) {
                  return n.id === sourceEdge.from;
                });
                var targetNode = nodes.find(function (n) {
                  return n.id === targetEdge.to;
                });
                if (sourceNode && targetNode) {
                  var canLink = onNodeLinkCheck === null || onNodeLinkCheck === void 0 ? void 0 : onNodeLinkCheck(newNodes, newEdges, sourceNode, targetNode);
                  if (canLink === undefined || canLink) {
                    newEdges.push({
                      id: "".concat(sourceNode.id, "-").concat(targetNode.id),
                      from: sourceNode.id,
                      to: targetNode.id,
                      parent: sourceNode === null || sourceNode === void 0 ? void 0 : sourceNode.parent
                    });
                  }
                }
              };
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                _loop3();
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          };
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      };
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    return {
      edges: newEdges,
      nodes: newNodes
    };
  }
  /**
   * Helper function to remove a node and its related edges.
   */
  function removeNode(nodes, edges, removeNodes) {
    if (!Array.isArray(removeNodes)) {
      removeNodes = [removeNodes];
    }
    var newNodes = [];
    var newEdges = [];
    var _iterator8 = _createForOfIteratorHelper(nodes),
      _step8;
    try {
      var _loop4 = function _loop4() {
        var node = _step8.value;
        var has = removeNodes.some(function (n) {
          return n === node.id;
        });
        if (!has) {
          newNodes.push(node);
        }
      };
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        _loop4();
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    var _iterator9 = _createForOfIteratorHelper(edges),
      _step9;
    try {
      var _loop5 = function _loop5() {
        var edge = _step9.value;
        var has = removeNodes.some(function (n) {
          return n === edge.from || n === edge.to;
        });
        if (!has) {
          newEdges.push(edge);
        }
      };
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        _loop5();
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
    return {
      nodes: newNodes,
      edges: newEdges
    };
  }
  /**
   * Helper function to remove a node's related edges.
   */
  function removeEdgesFromNode(nodeId, edges) {
    return edges.filter(function (edge) {
      return !(edge.to === nodeId || edge.from === nodeId);
    });
  }
  /**
   * Remove edge(s)
   */
  function removeEdge(edges, edge) {
    var deletions = !Array.isArray(edge) ? [edge] : edge;
    var edgeIds = deletions.map(function (e) {
      return e.id;
    });
    return edges.filter(function (e) {
      return !edgeIds.includes(e.id);
    });
  }
  /**
   * Create an edge given 2 nodes.
   */
  function createEdgeFromNodes(fromNode, toNode) {
    return {
      id: "".concat(fromNode.id, "-").concat(toNode.id),
      from: fromNode.id,
      to: toNode.id,
      parent: toNode.parent
    };
  }
  /**
   * Add a node and optional edge.
   */
  function addNodeAndEdge(nodes, edges, node, toNode) {
    return {
      nodes: [].concat(_toConsumableArray(nodes), [node]),
      edges: [].concat(_toConsumableArray(edges), _toConsumableArray(toNode ? [createEdgeFromNodes(toNode, node)] : []))
    };
  }
  var useSelection = function useSelection(_ref23) {
    var _ref23$selections = _ref23.selections,
      selections = _ref23$selections === void 0 ? [] : _ref23$selections,
      _ref23$nodes = _ref23.nodes,
      nodes = _ref23$nodes === void 0 ? [] : _ref23$nodes,
      _ref23$edges = _ref23.edges,
      edges = _ref23$edges === void 0 ? [] : _ref23$edges,
      _ref23$hotkeys = _ref23.hotkeys,
      hotkeys = _ref23$hotkeys === void 0 ? ['selectAll', 'deselect', 'delete'] : _ref23$hotkeys,
      disabled = _ref23.disabled,
      onSelection = _ref23.onSelection,
      onDataChange = _ref23.onDataChange;
    var _react$useState39 = react.useState(selections),
      _react$useState40 = _slicedToArray(_react$useState39, 2),
      internalSelections = _react$useState40[0],
      setInternalSelections = _react$useState40[1];
    var _react$useState41 = react.useState(false),
      _react$useState42 = _slicedToArray(_react$useState41, 2),
      metaKeyDown = _react$useState42[0],
      setMetaKeyDown = _react$useState42[1];
    var addSelection = function addSelection(item) {
      if (!disabled) {
        var has = internalSelections.includes(item);
        if (!has) {
          var next = [].concat(_toConsumableArray(internalSelections), [item]);
          onSelection === null || onSelection === void 0 ? void 0 : onSelection(next);
          setInternalSelections(next);
        }
      }
    };
    var removeSelection = function removeSelection(item) {
      if (!disabled) {
        var has = internalSelections.includes(item);
        if (has) {
          var next = internalSelections.filter(function (i) {
            return i !== item;
          });
          onSelection === null || onSelection === void 0 ? void 0 : onSelection(next);
          setInternalSelections(next);
        }
      }
    };
    var toggleSelection = function toggleSelection(item) {
      var has = internalSelections.includes(item);
      if (has) {
        removeSelection(item);
      } else {
        addSelection(item);
      }
    };
    var clearSelections = function clearSelections() {
      var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!disabled) {
        setInternalSelections(next);
        onSelection === null || onSelection === void 0 ? void 0 : onSelection(next);
      }
    };
    var onClick = function onClick(event, data) {
      event.preventDefault();
      event.stopPropagation();
      if (!metaKeyDown) {
        clearSelections([data.id]);
      } else {
        toggleSelection(data.id);
      }
      setMetaKeyDown(false);
    };
    var onKeyDown = function onKeyDown(event) {
      event.preventDefault();
      setMetaKeyDown(event.metaKey || event.ctrlKey);
    };
    var onCanvasClick = function onCanvasClick() {
      clearSelections();
      setMetaKeyDown(false);
    };
    reakeys.useHotkeys([{
      name: 'Select All',
      keys: 'mod+a',
      disabled: !hotkeys.includes('selectAll'),
      category: 'Canvas',
      description: 'Select all nodes and edges',
      callback: function callback(event) {
        event.preventDefault();
        if (!disabled) {
          var next = nodes.map(function (n) {
            return n.id;
          });
          onDataChange === null || onDataChange === void 0 ? void 0 : onDataChange(nodes, edges);
          onSelection === null || onSelection === void 0 ? void 0 : onSelection(next);
          setInternalSelections(next);
        }
      }
    }, {
      name: 'Delete Selections',
      category: 'Canvas',
      disabled: !hotkeys.includes('delete'),
      description: 'Delete selected nodes and edges',
      keys: 'backspace',
      callback: function callback(event) {
        if (!disabled) {
          event.preventDefault();
          var result = removeNode(nodes, edges, internalSelections);
          onDataChange === null || onDataChange === void 0 ? void 0 : onDataChange(result.nodes, result.edges);
          onSelection === null || onSelection === void 0 ? void 0 : onSelection([]);
          setInternalSelections([]);
        }
      }
    }, {
      name: 'Deselect Selections',
      category: 'Canvas',
      disabled: !hotkeys.includes('deselect'),
      description: 'Deselect selected nodes and edges',
      keys: 'escape',
      callback: function callback(event) {
        if (!disabled) {
          event.preventDefault();
          onSelection === null || onSelection === void 0 ? void 0 : onSelection([]);
          setInternalSelections([]);
        }
      }
    }]);
    return {
      onClick: onClick,
      onKeyDown: onKeyDown,
      onCanvasClick: onCanvasClick,
      selections: internalSelections,
      clearSelections: clearSelections,
      addSelection: addSelection,
      removeSelection: removeSelection,
      toggleSelection: toggleSelection,
      setSelections: setInternalSelections
    };
  };
  var useUndo = function useUndo(_ref24) {
    var nodes = _ref24.nodes,
      edges = _ref24.edges,
      disabled = _ref24.disabled,
      _ref24$maxHistory = _ref24.maxHistory,
      maxHistory = _ref24$maxHistory === void 0 ? 20 : _ref24$maxHistory,
      onUndoRedo = _ref24.onUndoRedo;
    var _react$useState43 = react.useState(false),
      _react$useState44 = _slicedToArray(_react$useState43, 2),
      canUndo = _react$useState44[0],
      setCanUndo = _react$useState44[1];
    var _react$useState45 = react.useState(false),
      _react$useState46 = _slicedToArray(_react$useState45, 2),
      canRedo = _react$useState46[0],
      setCanRedo = _react$useState46[1];
    var manager = react.useRef(new Undoo__default['default']({
      maxLength: maxHistory
    }));
    // Reference: https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
    var callbackRef = react.useRef(onUndoRedo);
    react.useEffect(function () {
      callbackRef.current = onUndoRedo;
    }, [onUndoRedo]);
    react.useEffect(function () {
      manager.current.save({
        nodes: nodes,
        edges: edges
      });
      setCanUndo(manager.current.canUndo());
      setCanRedo(manager.current.canRedo());
    }, [nodes, edges]);
    var undo = react.useCallback(function () {
      manager.current.undo(function (state) {
        var nextUndo = manager.current.canUndo();
        var nextRedo = manager.current.canRedo();
        setCanUndo(nextUndo);
        setCanRedo(nextRedo);
        callbackRef.current(Object.assign(Object.assign({}, state), {
          type: 'undo',
          canUndo: nextUndo,
          canRedo: nextRedo
        }));
      });
    }, []);
    var redo = react.useCallback(function () {
      manager.current.redo(function (state) {
        var nextUndo = manager.current.canUndo();
        var nextRedo = manager.current.canRedo();
        setCanUndo(nextUndo);
        setCanRedo(nextRedo);
        callbackRef.current(Object.assign(Object.assign({}, state), {
          type: 'redo',
          canUndo: nextUndo,
          canRedo: nextRedo
        }));
      });
    }, []);
    var clear = react.useCallback(function (nodes, edges) {
      manager.current.clear();
      setCanUndo(false);
      setCanRedo(false);
      callbackRef.current({
        type: 'clear',
        canUndo: false,
        canRedo: false
      });
      manager.current.save({
        nodes: nodes,
        edges: edges
      });
    }, []);
    reakeys.useHotkeys([{
      name: 'Undo',
      keys: 'mod+z',
      category: 'Canvas',
      description: 'Undo changes',
      callback: function callback(event) {
        event.preventDefault();
        if (!disabled && canUndo) {
          undo();
        }
      }
    }, {
      name: 'Redo',
      keys: 'mod+shift+z',
      category: 'Canvas',
      description: 'Redo changes',
      callback: function callback(event) {
        event.preventDefault();
        if (!disabled && canRedo) {
          redo();
        }
      }
    }]);
    return {
      canUndo: canUndo,
      canRedo: canRedo,
      count: function count() {
        return manager.current.count();
      },
      history: function history() {
        return manager.current.history();
      },
      clear: clear,
      redo: redo,
      undo: undo
    };
  };
  var _buildPoints = function buildPoints(nodes, parent) {
    var _a;
    var results = [];
    if (nodes === null || nodes === void 0 ? void 0 : nodes.length) {
      var _iterator10 = _createForOfIteratorHelper(nodes),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var node = _step10.value;
          var x = node.x;
          var y = node.y;
          // NOTE: If we have a parent, let's update the points
          // to account for the parent's position
          if (parent) {
            x = parent.x + x;
            y = parent.y + y;
          }
          var points = [
          // top-left
          new kldAffine.Point2D(x, y),
          // bottom-right
          new kldAffine.Point2D(x + node.width, y + node.height)];
          results.push({
            points: points,
            node: node
          });
          if ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) {
            results.push.apply(results, _toConsumableArray(_buildPoints(node.children, node)));
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
    return results;
  };
  var distanceFromNode = function distanceFromNode(mousePoint, node) {
    var _node$points = _slicedToArray(node.points, 2),
      tl = _node$points[0],
      br = _node$points[1];
    var dx = 0;
    var dy = 0;
    // Compute distance to elem in X
    if (mousePoint.x < tl.x) {
      dx = tl.x - mousePoint.x;
    } else if (mousePoint.x > br.x) {
      dx = br.x - mousePoint.x;
    }
    // Compute distance to elem in Y
    if (mousePoint.y < tl.y) {
      dy = tl.y - mousePoint.y;
    } else if (mousePoint.y > br.y) {
      dy = br.y - mousePoint.y;
    }
    return Math.floor(Math.sqrt(dx * dx + dy * dy));
  };
  var findNodeIntersection = function findNodeIntersection(event, matrix, points, minDistance) {
    var cubes = [];
    var mousePoint = new kldAffine.Point2D(event.x, event.y).transform(matrix);
    var _iterator11 = _createForOfIteratorHelper(points),
      _step11;
    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var point = _step11.value;
        // TODO: Make this support other shape types...
        var intersects = kldIntersections.IntersectionQuery.pointInRectangle(mousePoint, point.points[0], point.points[1]);
        // Calc the distances
        // https://github.com/thelonious/kld-affine/issues/24
        var minDist = distanceFromNode(mousePoint, point);
        cubes.push({
          node: point.node,
          minDist: minDist,
          intersects: intersects
        });
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
    var foundDist = minDistance;
    var intersectedNodeId = null;
    var foundNodeId = null;
    for (var _i = 0, _cubes = cubes; _i < _cubes.length; _i++) {
      var cube = _cubes[_i];
      if (cube.minDist < foundDist && !cube.intersects) {
        foundNodeId = cube.node.id;
        foundDist = cube.minDist;
      }
      if (cube.intersects) {
        intersectedNodeId = cube.node.id;
      }
    }
    if (intersectedNodeId) {
      // We are are just inside a node already
      // and there is no closer children ( nested case )
      if (!foundNodeId || foundNodeId === intersectedNodeId) {
        // If we are inside the intersected node and its the
        // closest node, let's reset the distance to 0
        foundNodeId = intersectedNodeId;
        foundDist = 0;
      }
    }
    return {
      intersectedNodeId: intersectedNodeId,
      foundNodeId: foundNodeId,
      foundDist: foundDist
    };
  };
  var useProximity = function useProximity(_a) {
    var canvasRef = _a.canvasRef,
      disabled = _a.disabled,
      _a$minDistance = _a.minDistance,
      minDistance = _a$minDistance === void 0 ? 40 : _a$minDistance,
      rest = __rest(_a, ["canvasRef", "disabled", "minDistance"]);
    var lastIntersectRef = react.useRef(null);
    var lastMatchRef = react.useRef(null);
    var lastDistance = react.useRef(null);
    var frame = react.useRef(0);
    // Reference: https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
    var eventRefs = react.useRef(rest);
    react.useEffect(function () {
      eventRefs.current = rest;
    }, [rest]);
    var _react$useState47 = react.useState(null),
      _react$useState48 = _slicedToArray(_react$useState47, 2),
      match = _react$useState48[0],
      setMatch = _react$useState48[1];
    var _react$useState49 = react.useState(null),
      _react$useState50 = _slicedToArray(_react$useState49, 2),
      matrix = _react$useState50[0],
      setMatrix = _react$useState50[1];
    var _react$useState51 = react.useState(null),
      _react$useState52 = _slicedToArray(_react$useState51, 2),
      points = _react$useState52[0],
      setPoints = _react$useState52[1];
    var onDragStart = react.useCallback(function () {
      if (disabled) {
        return;
      }
      var ref = canvasRef.current;
      // @ts-ignore
      setMatrix(getCoords(ref));
      setPoints(_buildPoints(ref.layout.children));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);
    var onDrag = react.useCallback(function (event) {
      if (!matrix || disabled) {
        return;
      }
      var _eventRefs$current = eventRefs.current,
        onMatchChange = _eventRefs$current.onMatchChange,
        onIntersects = _eventRefs$current.onIntersects,
        onDistanceChange = _eventRefs$current.onDistanceChange;
      var _findNodeIntersection = findNodeIntersection(event, matrix, points, minDistance),
        intersectedNodeId = _findNodeIntersection.intersectedNodeId,
        foundNodeId = _findNodeIntersection.foundNodeId,
        foundDist = _findNodeIntersection.foundDist;
      var nextDist = foundDist !== minDistance ? foundDist : null;
      if (foundNodeId !== lastMatchRef.current) {
        onMatchChange === null || onMatchChange === void 0 ? void 0 : onMatchChange(foundNodeId, foundDist);
      }
      if (intersectedNodeId !== lastIntersectRef.current) {
        onIntersects === null || onIntersects === void 0 ? void 0 : onIntersects(intersectedNodeId);
      }
      if (onDistanceChange && nextDist !== lastDistance.current) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function () {
          onDistanceChange(nextDist);
        });
      }
      // Hold these in refs for race cases
      lastIntersectRef.current = intersectedNodeId;
      lastMatchRef.current = foundNodeId;
      lastDistance.current = nextDist;
      setMatch(foundNodeId);
    }, [matrix, disabled, minDistance, points]);
    react.useEffect(function () {
      return function () {
        return cancelAnimationFrame(frame.current);
      };
    });
    var onDragEnd = react.useCallback(function () {
      if (!disabled) {
        setMatch(null);
        setMatrix(null);
        setPoints(null);
      }
    }, [disabled]);
    return {
      match: match,
      onDragStart: onDragStart,
      onDrag: onDrag,
      onDragEnd: onDragEnd
    };
  };

  /**
   * Helper function to determine if edge already has a link.
   */
  function hasLink(edges, from, to) {
    return edges.some(function (e) {
      return e.from === from.id && e.to === to.id;
    });
  }
  /**
   * Get sources pointing to a node.
   */
  function getSourceNodesForTargetId(nodes, edges, nodeId) {
    var sourceNodeIds = edges.reduce(function (acc, edge) {
      if (edge.to === nodeId) {
        acc.push(edge.from);
      }
      return acc;
    }, []);
    var node = nodes.find(function (n) {
      return n.id === nodeId;
    });
    if (node === null || node === void 0 ? void 0 : node.parent) {
      sourceNodeIds.push(node.parent);
    }
    return nodes.filter(function (n) {
      return sourceNodeIds.includes(n.id);
    });
  }
  /**
   * Detect if there is a circular reference from the from to the source node.
   */
  function detectCircular(nodes, edges, fromNode, toNode) {
    var found = false;
    var _traverse = function traverse(nodeId) {
      var sourceNodes = getSourceNodesForTargetId(nodes, edges, nodeId);
      var _iterator12 = _createForOfIteratorHelper(sourceNodes),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var node = _step12.value;
          if (node.id !== toNode.id) {
            _traverse(node.id);
          } else {
            found = true;
            break;
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    };
    _traverse(fromNode.id);
    return found;
  }
  /**
   * Given a node id, get all the parent nodes recursively.
   */
  var getParentsForNodeId = function getParentsForNodeId(nodes, edges, startId) {
    var result = [];
    var _traverse2 = function traverse(nodeId) {
      var sourceNodes = getSourceNodesForTargetId(nodes, edges, nodeId);
      var _iterator13 = _createForOfIteratorHelper(sourceNodes),
        _step13;
      try {
        var _loop6 = function _loop6() {
          var node = _step13.value;
          var has = result.find(function (n) {
            return n.id === node.id;
          });
          if (!has) {
            result.push(node);
            _traverse2(node.id);
          }
        };
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          _loop6();
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    };
    _traverse2(startId);
    return result;
  };
  /**
   * Get edge data given a node.
   */
  function getEdgesByNode(edges, node) {
    var to = [];
    var from = [];
    var _iterator14 = _createForOfIteratorHelper(edges),
      _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var edge = _step14.value;
        if (edge.to === node.id) {
          to.push(edge);
        }
        if (edge.from === node.id) {
          from.push(edge);
        }
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
    return {
      to: to,
      from: from,
      all: [].concat(to, from)
    };
  }
  exports.Add = Add;
  exports.Arrow = Arrow;
  exports.Canvas = Canvas;
  exports.CanvasContext = CanvasContext;
  exports.CanvasProvider = CanvasProvider;
  exports.Edge = Edge;
  exports.Icon = Icon;
  exports.Label = Label;
  exports.MarkerArrow = MarkerArrow;
  exports.Node = _Node;
  exports.Port = Port;
  exports.Remove = Remove;
  exports.addNodeAndEdge = addNodeAndEdge;
  exports.checkNodeLinkable = checkNodeLinkable;
  exports.createEdgeFromNodes = createEdgeFromNodes;
  exports.detectCircular = detectCircular;
  exports.elkLayout = elkLayout;
  exports.findNestedNode = findNestedNode;
  exports.formatText = formatText;
  exports.getCoords = getCoords;
  exports.getDragNodeData = getDragNodeData;
  exports.getEdgesByNode = getEdgesByNode;
  exports.getParentsForNodeId = getParentsForNodeId;
  exports.hasLink = hasLink;
  exports.measureText = measureText;
  exports.parsePadding = parsePadding;
  exports.removeAndUpsertNodes = removeAndUpsertNodes;
  exports.removeEdge = removeEdge;
  exports.removeEdgesFromNode = removeEdgesFromNode;
  exports.removeNode = removeNode;
  exports.upsertNode = upsertNode;
  exports.useCanvas = useCanvas;
  exports.useEdgeDrag = useEdgeDrag;
  exports.useLayout = useLayout;
  exports.useNodeDrag = useNodeDrag;
  exports.useProximity = useProximity;
  exports.useSelection = useSelection;
  exports.useUndo = useUndo;
  exports.useZoom = useZoom;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});